/* eslint-disable */
// @ts-nocheck
export const AdvieskostenVormType = Object.freeze({
    "01 Voldoen uit eigen middelen": "01 Voldoen uit eigen middelen",
    "02 Meefinancieren in de hypotheek": "02 Meefinancieren in de hypotheek",
    "AA01 Voldoen uit eigen middelen": "AA01 Voldoen uit eigen middelen",
    "AA02 Meefinancieren in de hypotheek": "AA02 Meefinancieren in de hypotheek",
});
export const AdviesTypeType = Object.freeze({
    "01 Execution only": "01 Execution only",
    "02 Advies": "02 Advies",
    "03 Bemiddeling": "03 Bemiddeling",
    "04 Advies & Bemiddeling": "04 Advies & Bemiddeling",
});
export const AflossingsVormType = Object.freeze({
    "01 Annuiteit": "01 Annuiteit",
    "02 Lineair": "02 Lineair",
    "03 Levensverzekering": "03 Levensverzekering",
    "05 Aflossingsvrij": "05 Aflossingsvrij",
    "10 Beleggingshypotheek": "10 Beleggingshypotheek",
    "13 Spaarrekening": "13 Spaarrekening",
});
export const BelastingBoxType = Object.freeze({
    "01 Box 1": "01 Box 1",
    "03 Box 3": "03 Box 3",
    "04 Box 1 / Box 3": "04 Box 1 / Box 3",
});
export const BeleggingprofielMijType = Object.freeze({
    "AA001 zeer defensief": "AA001 zeer defensief",
    "AA002 defensief": "AA002 defensief",
    "AA003 matig defensief": "AA003 matig defensief",
    "AA004 matig offensief": "AA004 matig offensief",
    "AA005 offensief": "AA005 offensief",
    "AA006 zeer offensief": "AA006 zeer offensief",
    "RG001 Geel (defensief)": "RG001 Geel (defensief)",
    "RG002 Oranje (neutraal)": "RG002 Oranje (neutraal)",
    "RG003 Rood (offensief)": "RG003 Rood (offensief)",
    "RG004 Paars (zeer offensief)": "RG004 Paars (zeer offensief)",
    "SN003 Geel (defensief)": "SN003 Geel (defensief)",
    "SN004 Oranje (neutraal)": "SN004 Oranje (neutraal)",
    "SN005 Rood (offensief)": "SN005 Rood (offensief)",
    "SN006 Paars (zeer offensief)": "SN006 Paars (zeer offensief)",
});
export const BeleggingprofielUitkomstType = Object.freeze({
    "01 Zeer defensief": "01 Zeer defensief",
    "02 Defensief": "02 Defensief",
    "03 Gematigd": "03 Gematigd",
    "04 Neutraal": "04 Neutraal",
    "05 Gematigd offensief": "05 Gematigd offensief",
    "06 Offensief": "06 Offensief",
    "07 Zeer offensief": "07 Zeer offensief",
});
export const BerekeningsUitgangspuntType = Object.freeze({
    "01 Van premie naar kapitaal": "01 Van premie naar kapitaal",
    "02 Van kapitaal naar premie": "02 Van kapitaal naar premie",
});
export const BeroepType = Object.freeze({
    "0111 Docenten hoger onderwijs en hoogleraren": "0111 Docenten hoger onderwijs en hoogleraren",
    "0112 Docenten beroepsgerichte vakken secundair onderwijs": "0112 Docenten beroepsgerichte vakken secundair onderwijs",
    "0113 Docenten algemene vakken secundair onderwijs": "0113 Docenten algemene vakken secundair onderwijs",
    "0114 Leerkrachten basisonderwijs": "0114 Leerkrachten basisonderwijs",
    "0115 Onderwijskundigen en overige docenten": "0115 Onderwijskundigen en overige docenten",
    "0121 Sportinstructeurs": "0121 Sportinstructeurs",
    "0131 Leidsters kinderopvang en onderwijsassistenten": "0131 Leidsters kinderopvang en onderwijsassistenten",
    "0211 Bibliothecarissen en conservatoren": "0211 Bibliothecarissen en conservatoren",
    "0212 Auteurs en taalkundigen": "0212 Auteurs en taalkundigen",
    "0213 Journalisten": "0213 Journalisten",
    "0214 Beeldend kunstenaars": "0214 Beeldend kunstenaars",
    "0215 Uitvoerend kunstenaars": "0215 Uitvoerend kunstenaars",
    "0221 Grafisch vormgevers en productontwerpers": "0221 Grafisch vormgevers en productontwerpers",
    "0222 Fotografen en interieurontwerpers": "0222 Fotografen en interieurontwerpers",
    "0311 Adviseurs marketing, public relations en sales": "0311 Adviseurs marketing, public relations en sales",
    "0321 Vertegenwoordigers en inkopers": "0321 Vertegenwoordigers en inkopers",
    "0331 Winkeliers en teamleiders detailhandel": "0331 Winkeliers en teamleiders detailhandel",
    "0332 Verkoopmedewerkers detailhandel": "0332 Verkoopmedewerkers detailhandel",
    "0333 Kassamedewerkers": "0333 Kassamedewerkers",
    "0334 Callcentermedewerkers outbound en overige verkopers": "0334 Callcentermedewerkers outbound en overige verkopers",
    "0411 Accountants": "0411 Accountants",
    "0412 Financieel specialisten en economen": "0412 Financieel specialisten en economen",
    "0413 Bedrijfskundigen en organisatieadviseurs": "0413 Bedrijfskundigen en organisatieadviseurs",
    "0414 Beleidsadviseurs": "0414 Beleidsadviseurs",
    "0415 Specialisten personeels- en loopbaanontwikkeling": "0415 Specialisten personeels- en loopbaanontwikkeling",
    "0421 Boekhouders": "0421 Boekhouders",
    "0422 Zakelijke dienstverleners": "0422 Zakelijke dienstverleners",
    "0423 Directiesecretaresses": "0423 Directiesecretaresses",
    "0431 Administratief medewerkers": "0431 Administratief medewerkers",
    "0432 Secretaresses": "0432 Secretaresses",
    "0433 Receptionisten en telefonisten": "0433 Receptionisten en telefonisten",
    "0434 Boekhoudkundig medewerkers": "0434 Boekhoudkundig medewerkers",
    "0435 Transportplanners en logistiek medewerkers": "0435 Transportplanners en logistiek medewerkers",
    "0511 Algemeen directeuren": "0511 Algemeen directeuren",
    "0521 Managers zakelijke en administratieve dienstverlening": "0521 Managers zakelijke en administratieve dienstverlening",
    "0522 Managers verkoop en marketing": "0522 Managers verkoop en marketing",
    "0531 Managers productie": "0531 Managers productie",
    "0532 Managers logistiek": "0532 Managers logistiek",
    "0533 Managers ICT": "0533 Managers ICT",
    "0534 Managers zorginstellingen": "0534 Managers zorginstellingen",
    "0535 Managers onderwijs": "0535 Managers onderwijs",
    "0536 Managers gespecialiseerde dienstverlening": "0536 Managers gespecialiseerde dienstverlening",
    "0541 Managers horeca": "0541 Managers horeca",
    "0542 Managers detail- en groothandel": "0542 Managers detail- en groothandel",
    "0543 Managers commerciële en persoonlijke dienstverlening": "0543 Managers commerciële en persoonlijke dienstverlening",
    "0551 Managers z.n.d.": "0551 Managers z.n.d.",
    "0611 Overheidsbestuurders": "0611 Overheidsbestuurders",
    "0612 Overheidsambtenaren": "0612 Overheidsambtenaren",
    "0621 Juristen": "0621 Juristen",
    "0631 Politie-inspecteurs": "0631 Politie-inspecteurs",
    "0632 Politie en brandweer": "0632 Politie en brandweer",
    "0633 Beveiligingspersoneel": "0633 Beveiligingspersoneel",
    "0634 Militaire beroepen": "0634 Militaire beroepen",
    "0711 Biologen en natuurwetenschappers": "0711 Biologen en natuurwetenschappers",
    "0712 Ingenieurs (geen elektrotechniek)": "0712 Ingenieurs (geen elektrotechniek)",
    "0713 Elektrotechnisch ingenieurs": "0713 Elektrotechnisch ingenieurs",
    "0714 Architecten": "0714 Architecten",
    "0721 Technici bouwkunde en natuur": "0721 Technici bouwkunde en natuur",
    "0722 Productieleiders industrie en bouw": "0722 Productieleiders industrie en bouw",
    "0723 Procesoperators": "0723 Procesoperators",
    "0731 Bouwarbeiders ruwbouw": "0731 Bouwarbeiders ruwbouw",
    "0732 Timmerlieden": "0732 Timmerlieden",
    "0733 Bouwarbeiders afbouw": "0733 Bouwarbeiders afbouw",
    "0734 Loodgieters en pijpfitters": "0734 Loodgieters en pijpfitters",
    "0735 Schilders en metaalspuiters": "0735 Schilders en metaalspuiters",
    "0741 Metaalbewerkers en constructiewerkers": "0741 Metaalbewerkers en constructiewerkers",
    "0742 Lassers en plaatwerkers": "0742 Lassers en plaatwerkers",
    "0743 Automonteurs": "0743 Automonteurs",
    "0744 Machinemonteurs": "0744 Machinemonteurs",
    "0751 Slagers": "0751 Slagers",
    "0752 Bakkers": "0752 Bakkers",
    "0753 Productcontroleurs": "0753 Productcontroleurs",
    "0754 Meubelmakers, kleermakers en stoffeerders": "0754 Meubelmakers, kleermakers en stoffeerders",
    "0755 Medewerkers drukkerij en kunstnijverheid": "0755 Medewerkers drukkerij en kunstnijverheid",
    "0761 Elektriciens en elektronicamonteurs": "0761 Elektriciens en elektronicamonteurs",
    "0771 Productiemachinebedieners": "0771 Productiemachinebedieners",
    "0772 Assemblagemedewerkers": "0772 Assemblagemedewerkers",
    "0781 Hulpkrachten bouw en industrie": "0781 Hulpkrachten bouw en industrie",
    "0811 Software- en applicatieontwikkelaars": "0811 Software- en applicatieontwikkelaars",
    "0812 Databank- en netwerkspecialisten": "0812 Databank- en netwerkspecialisten",
    "0821 Gebruikersondersteuning ICT": "0821 Gebruikersondersteuning ICT",
    "0822 Radio- en televisietechnici": "0822 Radio- en televisietechnici",
    "0911 Land- en bosbouwers": "0911 Land- en bosbouwers",
    "0912 Hoveniers, tuinders en kwekers": "0912 Hoveniers, tuinders en kwekers",
    "0913 Veetelers": "0913 Veetelers",
    "0921 Hulpkrachten landbouw": "0921 Hulpkrachten landbouw",
    "1011 Artsen": "1011 Artsen",
    "1012 Gespecialiseerd verpleegkundigen": "1012 Gespecialiseerd verpleegkundigen",
    "1013 Fysiotherapeuten": "1013 Fysiotherapeuten",
    "1021 Maatschappelijk werkers": "1021 Maatschappelijk werkers",
    "1022 Psychologen en sociologen": "1022 Psychologen en sociologen",
    "1031 Laboranten": "1031 Laboranten",
    "1032 Apothekersassistenten": "1032 Apothekersassistenten",
    "1033 Verpleegkundigen (mbo)": "1033 Verpleegkundigen (mbo)",
    "1034 Medisch praktijkassistenten": "1034 Medisch praktijkassistenten",
    "1035 Medisch vakspecialisten": "1035 Medisch vakspecialisten",
    "1041 Sociaal werkers, groeps- en woonbegeleiders": "1041 Sociaal werkers, groeps- en woonbegeleiders",
    "1051 Verzorgenden": "1051 Verzorgenden",
    "1111 Reisbegeleiders": "1111 Reisbegeleiders",
    "1112 Koks": "1112 Koks",
    "1113 Kelners en barpersoneel": "1113 Kelners en barpersoneel",
    "1114 Kappers en schoonheidsspecialisten": "1114 Kappers en schoonheidsspecialisten",
    "1115 Conciërges en teamleiders schoonmaak": "1115 Conciërges en teamleiders schoonmaak",
    "1116 Verleners van overige persoonlijke diensten": "1116 Verleners van overige persoonlijke diensten",
    "1121 Schoonmakers": "1121 Schoonmakers",
    "1122 Keukenhulpen": "1122 Keukenhulpen",
    "1211 Dekofficieren en piloten": "1211 Dekofficieren en piloten",
    "1212 Chauffeurs auto's, taxi's en bestelwagens": "1212 Chauffeurs auto's, taxi's en bestelwagens",
    "1213 Buschauffeurs en trambestuurders": "1213 Buschauffeurs en trambestuurders",
    "1214 Vrachtwagenchauffeurs": "1214 Vrachtwagenchauffeurs",
    "1215 Bedieners mobiele machines": "1215 Bedieners mobiele machines",
    "1221 Laders, lossers en vakkenvullers": "1221 Laders, lossers en vakkenvullers",
    "1222 Vuilnisophalers en dagbladenbezorgers": "1222 Vuilnisophalers en dagbladenbezorgers",
});
export const BetalingsTermijnType = Object.freeze({
    "01 per maand": "01 per maand",
    "02 per 2 maanden": "02 per 2 maanden",
    "03 per kwartaal": "03 per kwartaal",
    "06 per halfjaar": "06 per halfjaar",
    "12 per jaar": "12 per jaar",
    "99 eenmalig": "99 eenmalig",
});
export const BijzObjectSoortType = Object.freeze({
    "01 Landgoed": "01 Landgoed",
    "02 Landhuis": "02 Landhuis",
    "03 Villa": "03 Villa",
    "04 Herenhuis": "04 Herenhuis",
    "05 Vrijstaand herenhuis": "05 Vrijstaand herenhuis",
    "06 Drive-in woning": "06 Drive-in woning",
    "07 Split-levelwoning": "07 Split-levelwoning",
    "08 Kwadrantwoning": "08 Kwadrantwoning",
    "09 Patiowoning": "09 Patiowoning",
    "10 Bungalow": "10 Bungalow",
    "11 Geschakelde bungalow": "11 Geschakelde bungalow",
    "12 Patiobungalow": "12 Patiobungalow",
    "13 Semi-bungalow": "13 Semi-bungalow",
    "14 Grachtenpand": "14 Grachtenpand",
    "15 Bijzonder architectonische woning": "15 Bijzonder architectonische woning",
    "16 Hofjeswoning": "16 Hofjeswoning",
    "17 Dijkwoning": "17 Dijkwoning",
    "18 Bedrijfs- of dienstwoning": "18 Bedrijfs- of dienstwoning",
    "19 Praktijkwoning": "19 Praktijkwoning",
    "20 Vrijstaande praktijkwoning": "20 Vrijstaande praktijkwoning",
    "21 Boerderij": "21 Boerderij",
    "22 Woonboerderij": "22 Woonboerderij",
    "23 Molen": "23 Molen",
    "24 Tinyhouse": "24 Tinyhouse",
    "25 Tijdelijke woning": "25 Tijdelijke woning",
    "26 Penthouse": "26 Penthouse",
    "27 Appartement": "27 Appartement",
    "28 Serviceflat": "28 Serviceflat",
    "29 Bel-etage": "29 Bel-etage",
    "30 Souterrain": "30 Souterrain",
    "31 Collectieve parkeerplaats bij woningen": "31 Collectieve parkeerplaats bij woningen",
    "32 Parkeerplaats in een gezamenlijke garage": "32 Parkeerplaats in een gezamenlijke garage",
    "33 Parkeerplaats op een parkeerterrein": "33 Parkeerplaats op een parkeerterrein",
});
export const BooleanType = Object.freeze({
    "J Ja": "J Ja",
    "N Nee": "N Nee",
});
export const BouwaardType = Object.freeze({
    "01 (Grotendeels) steen": "01 (Grotendeels) steen",
    "02 Deels hout, deels steen": "02 Deels hout, deels steen",
    "03 (Grotendeels) hout": "03 (Grotendeels) hout",
    "04 Beton": "04 Beton",
    "05 Staal": "05 Staal",
    "99 Overig": "99 Overig",
});
export const BronWaardebepalingType = Object.freeze({
    "01 Taxatierapport": "01 Taxatierapport",
    "02 WOZ": "02 WOZ",
    "03 Koop overeenkomst": "03 Koop overeenkomst",
    "04 Koop-/aanneem overeenkomst": "04 Koop-/aanneem overeenkomst",
    "05 Geveltaxatie": "05 Geveltaxatie",
    "06 Stichtingskosten": "06 Stichtingskosten",
    "07 Modelmatige taxatie": "07 Modelmatige taxatie",
    "08 Desktoptaxatie": "08 Desktoptaxatie",
});
export const BurgerlijkeStaatType = Object.freeze({
    "01 Gehuwd (gemeenschap van goederen)": "01 Gehuwd (gemeenschap van goederen)",
    "02 Gehuwd met huwelijkse voorwaarden": "02 Gehuwd met huwelijkse voorwaarden",
    "03 Alleenstaand": "03 Alleenstaand",
    "04 Samenwonend met samenlevingscontract": "04 Samenwonend met samenlevingscontract",
    "05 Samenwonend zonder samenlevingscontract": "05 Samenwonend zonder samenlevingscontract",
    "06 Partnerregistratie in gemeenschap van goederen": "06 Partnerregistratie in gemeenschap van goederen",
    "07 Partnerregistratie onder registratievoorwaarden": "07 Partnerregistratie onder registratievoorwaarden",
    "08 Gehuwd volgens buitenlands recht": "08 Gehuwd volgens buitenlands recht",
    "09 Gehuwd in beperkte gemeenschap van goederen": "09 Gehuwd in beperkte gemeenschap van goederen",
    "10 Partnerregistratie in beperkte gemeenschap van goederen": "10 Partnerregistratie in beperkte gemeenschap van goederen",
});
export const CodeBancaireDekkingMijType = Object.freeze({
    "AZ001 Allianz Plus Hypotheekrekening": "AZ001 Allianz Plus Hypotheekrekening",
    "AZ002 Allianz Plus Rekening": "AZ002 Allianz Plus Rekening",
    "CB001 Centraal Beheer Thuis Hypotheek Bankspaarrekening": "CB001 Centraal Beheer Thuis Hypotheek Bankspaarrekening",
    "HQ001 Solide Koers Bankspaar": "HQ001 Solide Koers Bankspaar",
    "HQ002 Solide Koers Beleggingsrekening": "HQ002 Solide Koers Beleggingsrekening",
    "OO001 Solide Koers Beleggingsrekening": "OO001 Solide Koers Beleggingsrekening",
});
export const CodeBancaireDekkingType = Object.freeze({
    "01 Spaarrekening": "01 Spaarrekening",
    "02 Beleggingsrekening (alleen fondsen)": "02 Beleggingsrekening (alleen fondsen)",
    "03 Effectenrekening (losse aandelen)": "03 Effectenrekening (losse aandelen)",
});
export const CodeDeelMijType = Object.freeze({
    "AA001 ABN AMRO Annuïteiten hypotheek": "AA001 ABN AMRO Annuïteiten hypotheek",
    "AA002 ABN AMRO Levensverzekeringhypotheek": "AA002 ABN AMRO Levensverzekeringhypotheek",
    "AA003 ABN AMRO Aflossingsvrije hypotheek": "AA003 ABN AMRO Aflossingsvrije hypotheek",
    "AA004 ABN AMRO Personal Business Hypotheek": "AA004 ABN AMRO Personal Business Hypotheek",
    "AA005 ABN AMRO Lineaire hypotheek": "AA005 ABN AMRO Lineaire hypotheek",
    "AA006 ABN AMRO Meegroeihypotheek": "AA006 ABN AMRO Meegroeihypotheek",
    "AA007 ABN AMRO Spaargroeihypotheek": "AA007 ABN AMRO Spaargroeihypotheek",
    "AA008 ABN AMRO Startzekerhypotheek": "AA008 ABN AMRO Startzekerhypotheek",
    "AA009 ABN AMRO BankSpaarhypotheek": "AA009 ABN AMRO BankSpaarhypotheek",
    "AA010 ABN AMRO Kapitaalgroei hypotheek": "AA010 ABN AMRO Kapitaalgroei hypotheek",
    "AA011 ABN AMRO Spaarhypotheek": "AA011 ABN AMRO Spaarhypotheek",
    "AA014 ABN AMRO Aflossingsvrij met verpanding": "AA014 ABN AMRO Aflossingsvrij met verpanding",
    "AA015 ABN AMRO Opbouw Hypotheek": "AA015 ABN AMRO Opbouw Hypotheek",
    "AA016 ABN AMRO Restschuld hypotheek annuitair": "AA016 ABN AMRO Restschuld hypotheek annuitair",
    "AA017 ABN AMRO Restschuld hypotheek lineair": "AA017 ABN AMRO Restschuld hypotheek lineair",
    "AA018 ABN AMRO Krediet hypotheek": "AA018 ABN AMRO Krediet hypotheek",
    "AA019 ABN AMRO Opeet hypotheek": "AA019 ABN AMRO Opeet hypotheek",
    "AA020 ABN AMRO Meerkeuze hypotheek": "AA020 ABN AMRO Meerkeuze hypotheek",
    "AA021 ABN AMRO Woon balans hypotheek": "AA021 ABN AMRO Woon balans hypotheek",
    "AA022 ABN AMRO Hybride hypotheek": "AA022 ABN AMRO Hybride hypotheek",
    "AA023 ABN AMRO SpaarInterlloyd": "AA023 ABN AMRO SpaarInterlloyd",
    "AA024 Duurzaam Wonen Annuïteiten Hypotheek": "AA024 Duurzaam Wonen Annuïteiten Hypotheek",
    "AA025 Duurzaam Wonen Lineaire Hypotheek": "AA025 Duurzaam Wonen Lineaire Hypotheek",
    "AA026 Overwaarde Hypotheek eenmalig": "AA026 Overwaarde Hypotheek eenmalig",
    "AA027 Overwaarde Hypotheek periodiek": "AA027 Overwaarde Hypotheek periodiek",
    "AA028 Tijdelijke Betaalstop Hypotheek": "AA028 Tijdelijke Betaalstop Hypotheek",
    "AB001 ABP Aflossingsvrije hypotheek": "AB001 ABP Aflossingsvrije hypotheek",
    "AB002 ABP Annuïteitenhypotheek": "AB002 ABP Annuïteitenhypotheek",
    "AB003 ABP Levenhypotheek": "AB003 ABP Levenhypotheek",
    "AB004 ABP Levenhypotheek met beleggingsrekening": "AB004 ABP Levenhypotheek met beleggingsrekening",
    "AB005 ABP Lineaire hypotheek": "AB005 ABP Lineaire hypotheek",
    "AB006 ABP Spaarhypotheek": "AB006 ABP Spaarhypotheek",
    "AB007 ABP Restschuld Annuïtair": "AB007 ABP Restschuld Annuïtair",
    "AB008 ABP Restschuld Lineair": "AB008 ABP Restschuld Lineair",
    "AE001 Aegon Aflossingsvrije hypotheek": "AE001 Aegon Aflossingsvrije hypotheek",
    "AE002 Aegon Annuïteitenhypotheek": "AE002 Aegon Annuïteitenhypotheek",
    "AE003 Aegon Levenhypotheek": "AE003 Aegon Levenhypotheek",
    "AE006 Aegon Spaarhypotheek": "AE006 Aegon Spaarhypotheek",
    "AE008 Aegon BankspaarHypotheek": "AE008 Aegon BankspaarHypotheek",
    "AE009 Aegon Lineaire Hypotheek": "AE009 Aegon Lineaire Hypotheek",
    "AE010 Aegon Duurzaamheidstarief Aflossingsvrije Hypotheek": "AE010 Aegon Duurzaamheidstarief Aflossingsvrije Hypotheek",
    "AE011 Aegon Duurzaamheidstarief Annuïteitenhypotheek": "AE011 Aegon Duurzaamheidstarief Annuïteitenhypotheek",
    "AE012 Aegon Duurzaamheidstarief Lineaire Hypotheek": "AE012 Aegon Duurzaamheidstarief Lineaire Hypotheek",
    "AK001 ASN Annuïteitenhypotheek": "AK001 ASN Annuïteitenhypotheek",
    "AK002 ASN Lineaire Hypotheek": "AK002 ASN Lineaire Hypotheek",
    "AK003 ASN Aflossingsvrije Hypotheek": "AK003 ASN Aflossingsvrije Hypotheek",
    "AK004 ASN Duurzaam Wonen (annuïteitenhypotheek)": "AK004 ASN Duurzaam Wonen (annuïteitenhypotheek)",
    "AK005 ASN Duurzaam Wonen (lineaire hypotheek)": "AK005 ASN Duurzaam Wonen (lineaire hypotheek)",
    "AK006 Restschuldfinanciering": "AK006 Restschuldfinanciering",
    "AK007 Bespaarhypotheek Aflossingsvrij": "AK007 Bespaarhypotheek Aflossingsvrij",
    "AK008 Bespaarhypotheek Annuitair": "AK008 Bespaarhypotheek Annuitair",
    "AK009 Bespaarhypotheek Lineair": "AK009 Bespaarhypotheek Lineair",
    "AQ001 Attens Hypotheken Aflossingsvrij": "AQ001 Attens Hypotheken Aflossingsvrij",
    "AQ002 Attens Hypotheken Annuïteit": "AQ002 Attens Hypotheken Annuïteit",
    "AQ003 Attens Hypotheken Lineair": "AQ003 Attens Hypotheken Lineair",
    "AQ004 Attens Hypotheken Groene Annuïteit": "AQ004 Attens Hypotheken Groene Annuïteit",
    "AQ005 Attens Hypotheken Groen Lineair": "AQ005 Attens Hypotheken Groen Lineair",
    "AR001 Argenta Annuiteit": "AR001 Argenta Annuiteit",
    "AR002 Argenta Leven": "AR002 Argenta Leven",
    "AR003 Argenta Aflossingsvrij": "AR003 Argenta Aflossingsvrij",
    "AR004 Argenta Belegrekening": "AR004 Argenta Belegrekening",
    "AR005 Argenta Spaarhypotheek": "AR005 Argenta Spaarhypotheek",
    "AR006 Argenta Special Line Spaarhypotheek": "AR006 Argenta Special Line Spaarhypotheek",
    "AR007 Argenta Spectrum Leven": "AR007 Argenta Spectrum Leven",
    "AR008 Argenta Spectrum Belegrekening": "AR008 Argenta Spectrum Belegrekening",
    "AR009 Argenta Spectrum Spaarhypotheek": "AR009 Argenta Spectrum Spaarhypotheek",
    "AR010 Argenta Spectrum Annuiteit Extra": "AR010 Argenta Spectrum Annuiteit Extra",
    "AR011 Argenta Spectrum Kosten Koper Lineair": "AR011 Argenta Spectrum Kosten Koper Lineair",
    "AR012 Argenta Lineair": "AR012 Argenta Lineair",
    "AR013 Argenta Groen Annuïteit": "AR013 Argenta Groen Annuïteit",
    "AR014 Argenta Groen Lineair": "AR014 Argenta Groen Lineair",
    "AU001 ASR Annuiteitenhypotheek": "AU001 ASR Annuiteitenhypotheek",
    "AU002 ASR Lineaire hypotheek": "AU002 ASR Lineaire hypotheek",
    "AU003 ASR Aflossingsvrije hypotheek": "AU003 ASR Aflossingsvrije hypotheek",
    "AU004 ASR Spaarhypotheek": "AU004 ASR Spaarhypotheek",
    "AU005 ASR Levenhypotheek": "AU005 ASR Levenhypotheek",
    "AU010 Restschuldfinanciering Annuitair": "AU010 Restschuldfinanciering Annuitair",
    "AU011 Restschuldfinanciering Lineair": "AU011 Restschuldfinanciering Lineair",
    "AU013 ASR Starters Hypotheek (aftrekbaar)": "AU013 ASR Starters Hypotheek (aftrekbaar)",
    "AU014 ASR Starters Hypotheek (niet aftrekbaar)": "AU014 ASR Starters Hypotheek (niet aftrekbaar)",
    "AU017 ASR Verduurzamingshypotheek": "AU017 ASR Verduurzamingshypotheek",
    "AU018 ASR Levensrente Hypotheek": "AU018 ASR Levensrente Hypotheek",
    "AW001 Annuïteiten Hypotheek": "AW001 Annuïteiten Hypotheek",
    "AW002 Lineaire Hypotheek": "AW002 Lineaire Hypotheek",
    "AW003 Aflossingsvrije Hypotheek": "AW003 Aflossingsvrije Hypotheek",
    "AW004 Restschuldfinanciering Annuïteit": "AW004 Restschuldfinanciering Annuïteit",
    "AW005 Restschuldfinanciering Lineair": "AW005 Restschuldfinanciering Lineair",
    "AZ001 Allianz Design Spaarhypotheek": "AZ001 Allianz Design Spaarhypotheek",
    "AZ004 Allianz Plus Hypotheek": "AZ004 Allianz Plus Hypotheek",
    "AZ007 Aflossingsvrij": "AZ007 Aflossingsvrij",
    "AZ008 Annuïtair": "AZ008 Annuïtair",
    "AZ009 Lineair": "AZ009 Lineair",
    "AZ010 Groen Annuïtair": "AZ010 Groen Annuïtair",
    "AZ011 Groen Lineair": "AZ011 Groen Lineair",
    "BB001 bijBouwe Aflossingsvrij": "BB001 bijBouwe Aflossingsvrij",
    "BB002 bijBouwe Annuitair": "BB002 bijBouwe Annuitair",
    "BB003 bijBouwe Lineair": "BB003 bijBouwe Lineair",
    "BB004 bijBouwe Online Aflossingsvrij ": "BB004 bijBouwe Online Aflossingsvrij ",
    "BB005 bijBouwe Online Annuitair ": "BB005 bijBouwe Online Annuitair ",
    "BB006 bijBouwe Online Lineair": "BB006 bijBouwe Online Lineair",
    "BB007 bijBouwe Vooruit Aflossingsvrij": "BB007 bijBouwe Vooruit Aflossingsvrij",
    "BB008 bijBouwe Vooruit Annuitair": "BB008 bijBouwe Vooruit Annuitair",
    "BB009 bijBouwe Vooruit Lineair": "BB009 bijBouwe Vooruit Lineair",
    "BB010 bijBouwe Vooruit Groen Annuitair": "BB010 bijBouwe Vooruit Groen Annuitair",
    "BB011 bijBouwe Vooruit Groen Lineair": "BB011 bijBouwe Vooruit Groen Lineair",
    "BL001 BLG Annuïteitenhypotheek": "BL001 BLG Annuïteitenhypotheek",
    "BL002 BLG Aflossingsvrije Hypotheek": "BL002 BLG Aflossingsvrije Hypotheek",
    "BL003 BLG Levenhypotheek": "BL003 BLG Levenhypotheek",
    "BL004 BLG Beleggingshypotheek": "BL004 BLG Beleggingshypotheek",
    "BL005 BLG Spaarhypotheek": "BL005 BLG Spaarhypotheek",
    "BL006 BLG Bankspaarhypotheek": "BL006 BLG Bankspaarhypotheek",
    "BL007 BLG Lineaire Hypotheek": "BL007 BLG Lineaire Hypotheek",
    "BL008 BLG Restschuldfinanciering": "BL008 BLG Restschuldfinanciering",
    "BL009 Duurzaam Wonen Annuitair": "BL009 Duurzaam Wonen Annuitair",
    "BL010 Duurzaam Wonen Lineair": "BL010 Duurzaam Wonen Lineair",
    "BL201 BLG Bespaarhypotheek Aflossingsvrij": "BL201 BLG Bespaarhypotheek Aflossingsvrij",
    "BL202 BLG Bespaarhypotheek Annuitair": "BL202 BLG Bespaarhypotheek Annuitair",
    "BL203 BLG Bespaarhypotheek Lineair": "BL203 BLG Bespaarhypotheek Lineair",
    "BN001 Annuiteiten Hypotheek": "BN001 Annuiteiten Hypotheek",
    "BN003 Aflossingsvrije Hypotheek": "BN003 Aflossingsvrije Hypotheek",
    "BN004 Lineaire Hypotheek": "BN004 Lineaire Hypotheek",
    "BN005 Belegging Hypotheek": "BN005 Belegging Hypotheek",
    "BN006 Hybride Spaar Hypotheek": "BN006 Hybride Spaar Hypotheek",
    "BN007 Hybride Hypotheek": "BN007 Hybride Hypotheek",
    "BN008 Universal Life Hypotheek": "BN008 Universal Life Hypotheek",
    "BN009 ReserVie Hypotheek": "BN009 ReserVie Hypotheek",
    "BN010 SpaarInvest Hypotheek": "BN010 SpaarInvest Hypotheek",
    "BN011 Life Invest Hypotheek": "BN011 Life Invest Hypotheek",
    "BN012 Spaarverzekering Hypotheek": "BN012 Spaarverzekering Hypotheek",
    "BN013 Bankspaar Hypotheek": "BN013 Bankspaar Hypotheek",
    "BN014 Hybride Bankspaar Hypotheek": "BN014 Hybride Bankspaar Hypotheek",
    "BQ001 Annuïteit": "BQ001 Annuïteit",
    "BQ002 Aflosvrij": "BQ002 Aflosvrij",
    "BQ003 Lineair": "BQ003 Lineair",
    "BS001 Bouwsteen Annuïteiten Hypotheek": "BS001 Bouwsteen Annuïteiten Hypotheek",
    "BS002 Bouwsteen Lineaire Hypotheek": "BS002 Bouwsteen Lineaire Hypotheek",
    "BS003 Bouwsteen Aflossingsvrije Hypotheek": "BS003 Bouwsteen Aflossingsvrije Hypotheek",
    "CB001 Centraal Beheer Thuis Hypotheek Aflossingsvrij": "CB001 Centraal Beheer Thuis Hypotheek Aflossingsvrij",
    "CB002 Centraal Beheer Thuis Hypotheek Annuïteit": "CB002 Centraal Beheer Thuis Hypotheek Annuïteit",
    "CB003 Centraal Beheer Thuis Hypotheek Lineair": "CB003 Centraal Beheer Thuis Hypotheek Lineair",
    "CB004 Centraal Beheer Thuis Hypotheek Bankspaar": "CB004 Centraal Beheer Thuis Hypotheek Bankspaar",
    "CB005 Centraal Beheer Thuis Hypotheek Spaar": "CB005 Centraal Beheer Thuis Hypotheek Spaar",
    "CB006 Centraal Beheer Thuis Hypotheek Leven": "CB006 Centraal Beheer Thuis Hypotheek Leven",
    "CB007 Centraal Beheer Thuis Hypotheek Restschuld Annuïtair": "CB007 Centraal Beheer Thuis Hypotheek Restschuld Annuïtair",
    "CB008 Centraal Beheer Thuis Hypotheek Restschuld Lineair": "CB008 Centraal Beheer Thuis Hypotheek Restschuld Lineair",
    "CB009 Centraal Beheer Basis Lijn Aflossingsvrij": "CB009 Centraal Beheer Basis Lijn Aflossingsvrij",
    "CB010 Centraal Beheer Basis Lijn Annuïteit": "CB010 Centraal Beheer Basis Lijn Annuïteit",
    "CB011 Centraal Beheer Basis Lijn Lineair": "CB011 Centraal Beheer Basis Lijn Lineair",
    "CB012 Centraal Beheer Basis Lijn Bankspaar": "CB012 Centraal Beheer Basis Lijn Bankspaar",
    "CB013 Centraal Beheer Basis Lijn Spaar": "CB013 Centraal Beheer Basis Lijn Spaar",
    "CB014 Centraal Beheer Basis Lijn Leven": "CB014 Centraal Beheer Basis Lijn Leven",
    "CB015 Centraal Beheer Basis Lijn Restschuld Annuïtair": "CB015 Centraal Beheer Basis Lijn Restschuld Annuïtair",
    "CB016 Centraal Beheer Basis Lijn Restschuld Lineair": "CB016 Centraal Beheer Basis Lijn Restschuld Lineair",
    "CB017 Centraal Beheer Leef Hypotheek Aflossingsvrij": "CB017 Centraal Beheer Leef Hypotheek Aflossingsvrij",
    "CB018 Centraal Beheer Leef Hypotheek Annuïtair": "CB018 Centraal Beheer Leef Hypotheek Annuïtair",
    "CB019 Centraal Beheer Leef Hypotheek Lineair": "CB019 Centraal Beheer Leef Hypotheek Lineair",
    "CB020 Centraal Beheer Leef Hypotheek Groen Annuïtair": "CB020 Centraal Beheer Leef Hypotheek Groen Annuïtair",
    "CB021 Centraal Beheer Leef Hypotheek Groen Lineair": "CB021 Centraal Beheer Leef Hypotheek Groen Lineair",
    "CB022 Centraal Beheer Thuis Hypotheek Groen Annuïtair": "CB022 Centraal Beheer Thuis Hypotheek Groen Annuïtair",
    "CB023 Centraal Beheer Thuis Hypotheek Groen Lineair": "CB023 Centraal Beheer Thuis Hypotheek Groen Lineair",
    "CB024 Centraal Beheer Basis Lijn Groen Annuïtair": "CB024 Centraal Beheer Basis Lijn Groen Annuïtair",
    "CB025 Centraal Beheer Basis Lijn Groen Lineair": "CB025 Centraal Beheer Basis Lijn Groen Lineair",
    "CC001 Annuïteit": "CC001 Annuïteit",
    "CC002 Aflossingsvrij": "CC002 Aflossingsvrij",
    "CC003 Lineair": "CC003 Lineair",
    "CC004 Classic (leven)": "CC004 Classic (leven)",
    "CC005 Classic (belegging)": "CC005 Classic (belegging)",
    "CL001 Annuïteiten": "CL001 Annuïteiten",
    "CL002 Lineair": "CL002 Lineair",
    "CW001 Clarian Wonen Aflossingsvrij": "CW001 Clarian Wonen Aflossingsvrij",
    "CW002 Clarian Wonen Annuïtair": "CW002 Clarian Wonen Annuïtair",
    "CW003 Clarian Wonen Lineair": "CW003 Clarian Wonen Lineair",
    "DD001 Dynamic Aflossingsvrije Hypotheek": "DD001 Dynamic Aflossingsvrije Hypotheek",
    "DD002 Dynamic Annuïteiten Hypotheek": "DD002 Dynamic Annuïteiten Hypotheek",
    "DD003 Dynamic Lineaire Hypotheek": "DD003 Dynamic Lineaire Hypotheek",
    "DY001 Dynamic Aflossingsvrij": "DY001 Dynamic Aflossingsvrij",
    "DY002 Dynamic Annuitair": "DY002 Dynamic Annuitair",
    "DY003 Dynamic Lineair": "DY003 Dynamic Lineair",
    "FH001 Hybride": "FH001 Hybride",
    "FH002 Leven": "FH002 Leven",
    "FH003 Annuiteit": "FH003 Annuiteit",
    "FH004 Aflossingsvrij": "FH004 Aflossingsvrij",
    "FH005 Spaarverzekering": "FH005 Spaarverzekering",
    "FH007 Vermogens Opbouw Hypotheek": "FH007 Vermogens Opbouw Hypotheek",
    "FH008 Krediet": "FH008 Krediet",
    "FH009 Verzilverkrediet": "FH009 Verzilverkrediet",
    "FH010 Bankspaar": "FH010 Bankspaar",
    "FH011 Lineair": "FH011 Lineair",
    "FH012 Florius Restschuld hypotheek": "FH012 Florius Restschuld hypotheek",
    "FH013 Florius Restschuld hypotheek lineair": "FH013 Florius Restschuld hypotheek lineair",
    "FH014 Florius Verduurzaam Annuïteiten Hypotheek": "FH014 Florius Verduurzaam Annuïteiten Hypotheek",
    "FH015 Florius Verduurzaam Lineaire Hypotheek": "FH015 Florius Verduurzaam Lineaire Hypotheek",
    "FH016 Tijdelijke Betaalstop Hypotheek": "FH016 Tijdelijke Betaalstop Hypotheek",
    "GH001 Annuïteit": "GH001 Annuïteit",
    "GH002 Aflosvrij": "GH002 Aflosvrij",
    "GH003 Lineair": "GH003 Lineair",
    "HQ001 Aflossingsvrije Hypotheek": "HQ001 Aflossingsvrije Hypotheek",
    "HQ002 Annuïtaire Hypotheek": "HQ002 Annuïtaire Hypotheek",
    "HQ003 LevenHypotheek": "HQ003 LevenHypotheek",
    "HQ004 SpaarBeter Hypotheek": "HQ004 SpaarBeter Hypotheek",
    "HQ005 BeleggersHypotheek": "HQ005 BeleggersHypotheek",
    "HQ006 Lineaire Hypotheek": "HQ006 Lineaire Hypotheek",
    "HQ008 Bankspaar Hypotheek": "HQ008 Bankspaar Hypotheek",
    "HQ009 HQ VoordeelExtra Aflossingsvrij": "HQ009 HQ VoordeelExtra Aflossingsvrij",
    "HQ010 HQ VoordeelExtra Annuïteit": "HQ010 HQ VoordeelExtra Annuïteit",
    "HQ011 HQ VoordeelExtra Lineair": "HQ011 HQ VoordeelExtra Lineair",
    "HT001 Hypotrust Aflossingsvrij": "HT001 Hypotrust Aflossingsvrij",
    "HT002 Hypotrust Annuïteit": "HT002 Hypotrust Annuïteit",
    "HT003 Hypotrust Lineair": "HT003 Hypotrust Lineair",
    "HT004 Hypotrust Leven": "HT004 Hypotrust Leven",
    "HT005 Hypotrust SpaarToekomstHypotheek": "HT005 Hypotrust SpaarToekomstHypotheek",
    "HT006 Hypotrust Spaar-Optie-Hypotheek": "HT006 Hypotrust Spaar-Optie-Hypotheek",
    "HT007 Hypotrust Beleggershypotheek": "HT007 Hypotrust Beleggershypotheek",
    "HT008 Zeker Weten Hypotheek Spaarhypotheek": "HT008 Zeker Weten Hypotheek Spaarhypotheek",
    "HT009 Hypotrust Trend Aflossingsvrij": "HT009 Hypotrust Trend Aflossingsvrij",
    "HT010 Hypotrust Trend Annuiteit": "HT010 Hypotrust Trend Annuiteit",
    "HT011 Hypotrust Trend Lineair": "HT011 Hypotrust Trend Lineair",
    "HT012 Hypotrust Trend Leven": "HT012 Hypotrust Trend Leven",
    "HT013 Hypotrust Trend Spaar": "HT013 Hypotrust Trend Spaar",
    "HT014 Hypotrust Spaar OK Aflossingsvrij": "HT014 Hypotrust Spaar OK Aflossingsvrij",
    "HT015 Hypotrust Spaar OK Leven": "HT015 Hypotrust Spaar OK Leven",
    "HT016 Hypotrust Spaar OK Annuïteit": "HT016 Hypotrust Spaar OK Annuïteit",
    "HT017 Hypotrust Spaar OK Lineair": "HT017 Hypotrust Spaar OK Lineair",
    "HT018 Hypotrust Spaar OK Spaar": "HT018 Hypotrust Spaar OK Spaar",
    "HT019 Hypotrust OK Aflossingsvrij": "HT019 Hypotrust OK Aflossingsvrij",
    "HT020 Hypotrust OK Leven": "HT020 Hypotrust OK Leven",
    "HT021 Hypotrust OK Annuïteit": "HT021 Hypotrust OK Annuïteit",
    "HT022 Hypotrust OK Lineair": "HT022 Hypotrust OK Lineair",
    "HT023 Hypotrust OK Spaar": "HT023 Hypotrust OK Spaar",
    "HT024 Hypotrust Goede Start Annuïteit": "HT024 Hypotrust Goede Start Annuïteit",
    "HT025 Hypotrust Goede Start Lineair": "HT025 Hypotrust Goede Start Lineair",
    "HT026 Hypotrust Woon Bewust Aflossingsvrij": "HT026 Hypotrust Woon Bewust Aflossingsvrij",
    "HT027 Hypotrust Woon Bewust Annuïteit": "HT027 Hypotrust Woon Bewust Annuïteit",
    "HT028 Hypotrust Woon Bewust Lineair": "HT028 Hypotrust Woon Bewust Lineair",
    "HT029 Hypotrust ELAN Aflossingsvrij": "HT029 Hypotrust ELAN Aflossingsvrij",
    "HT030 Hypotrust ELAN Annuïteit": "HT030 Hypotrust ELAN Annuïteit",
    "HT031 Hypotrust ELAN Lineair": "HT031 Hypotrust ELAN Lineair",
    "HT032 Hypotrust Comfort Standaard Aflossingsvrij": "HT032 Hypotrust Comfort Standaard Aflossingsvrij",
    "HT033 Hypotrust Comfort Standaard Annuïteiten": "HT033 Hypotrust Comfort Standaard Annuïteiten",
    "HT034 Hypotrust Comfort Standaard Lineair": "HT034 Hypotrust Comfort Standaard Lineair",
    "HT035 Hypotrust Comfort Standaard Leven": "HT035 Hypotrust Comfort Standaard Leven",
    "HT036 Hypotrust Comfort Profijt Aflossingsvrij": "HT036 Hypotrust Comfort Profijt Aflossingsvrij",
    "HT037 Hypotrust Comfort Profijt Annuïteiten": "HT037 Hypotrust Comfort Profijt Annuïteiten",
    "HT038 Hypotrust Comfort Profijt Lineair": "HT038 Hypotrust Comfort Profijt Lineair",
    "HT039 Hypotrust Comfort Profijt Leven": "HT039 Hypotrust Comfort Profijt Leven",
    "HT040 Hypotrust ELAN Plus Aflossingsvrij": "HT040 Hypotrust ELAN Plus Aflossingsvrij",
    "HT041 Hypotrust ELAN Plus Annuïteit": "HT041 Hypotrust ELAN Plus Annuïteit",
    "HT042 Hypotrust ELAN Plus Lineair": "HT042 Hypotrust ELAN Plus Lineair",
    "HT043 Hypotrust Vrij Leven Aflossingsvrij": "HT043 Hypotrust Vrij Leven Aflossingsvrij",
    "HT044 Hypotrust Vrij Leven Annuïtair": "HT044 Hypotrust Vrij Leven Annuïtair",
    "HT045 Hypotrust Vrij Leven Lineair": "HT045 Hypotrust Vrij Leven Lineair",
    "HT046 Hypotrust Woon Bewust Groen Annuïteit": "HT046 Hypotrust Woon Bewust Groen Annuïteit",
    "HT047 Hypotrust Woon Bewust Groen Lineair": "HT047 Hypotrust Woon Bewust Groen Lineair",
    "HT048 Hypotrust OK Groen Annuïteit": "HT048 Hypotrust OK Groen Annuïteit",
    "HT049 Hypotrust OK Groen Lineair": "HT049 Hypotrust OK Groen Lineair",
    "HV001 HollandWoont Aflossingsvrij": "HV001 HollandWoont Aflossingsvrij",
    "HV002 HollandWoont Annuitair": "HV002 HollandWoont Annuitair",
    "HV003 HollandWoont Lineair": "HV003 HollandWoont Lineair",
    "IM001 Impact Annuïteit": "IM001 Impact Annuïteit",
    "IM002 Impact Lineair": "IM002 Impact Lineair",
    "IM003 Impact Aflossingsvrij": "IM003 Impact Aflossingsvrij",
    "IN001 Aflossingsvrije Hypotheek": "IN001 Aflossingsvrije Hypotheek",
    "IN002 Annuiteitenhypotheek": "IN002 Annuiteitenhypotheek",
    "IN003 Lineaire Hypotheek": "IN003 Lineaire Hypotheek",
    "IN004 Maatwerkhypotheek": "IN004 Maatwerkhypotheek",
    "IN005 Fondsenmix Hypotheek": "IN005 Fondsenmix Hypotheek",
    "IN006 Levenhypotheek": "IN006 Levenhypotheek",
    "IN007 Beleggershypotheek": "IN007 Beleggershypotheek",
    "IN008 Krediethypotheek": "IN008 Krediethypotheek",
    "IN009 Meerwaardehypotheek": "IN009 Meerwaardehypotheek",
    "IN010 Spaarhypotheek": "IN010 Spaarhypotheek",
    "IN011 Optimaalhypotheek": "IN011 Optimaalhypotheek",
    "IN012 Fondsenmix Hypotheek (Extra lenen)": "IN012 Fondsenmix Hypotheek (Extra lenen)",
    "IN013 Beleggershypotheek (Extra lenen)": "IN013 Beleggershypotheek (Extra lenen)",
    "IN014 Bankspaarhypotheek variant 1": "IN014 Bankspaarhypotheek variant 1",
    "IN015 Bankspaarhypotheek variant 2": "IN015 Bankspaarhypotheek variant 2",
    "IN016 Bankspaarhypotheek": "IN016 Bankspaarhypotheek",
    "IN017 Restschuldfinanciering Annuitair": "IN017 Restschuldfinanciering Annuitair",
    "IN018 Restschuldfinanciering Lineair": "IN018 Restschuldfinanciering Lineair",
    "IQ001 IQWOON Aflossingsvrij": "IQ001 IQWOON Aflossingsvrij",
    "IQ002 IQWOON Annuïteit": "IQ002 IQWOON Annuïteit",
    "IQ003 IQWOON Lineair": "IQ003 IQWOON Lineair",
    "IQ004 IQWOON Leven": "IQ004 IQWOON Leven",
    "KB001 Aflossingsvrij": "KB001 Aflossingsvrij",
    "KB002 Annuïteit": "KB002 Annuïteit",
    "KB003 Lineair": "KB003 Lineair",
    "KB004 Duurzaamheid Annuïteit": "KB004 Duurzaamheid Annuïteit",
    "KB005 Duurzaamheid Lineair": "KB005 Duurzaamheid Lineair",
    "LK001 Annuiteit": "LK001 Annuiteit",
    "LK002 Lineair": "LK002 Lineair",
    "LK003 Aflossingsvrij": "LK003 Aflossingsvrij",
    "LK004 Aflossingsvrij (84)": "LK004 Aflossingsvrij (84)",
    "LK005 Lineair Restschuld": "LK005 Lineair Restschuld",
    "LL001 Lloyds Bank Annuïteiten Hypotheek": "LL001 Lloyds Bank Annuïteiten Hypotheek",
    "LL002 Lloyds Bank Aflossingsvrije Hypotheek": "LL002 Lloyds Bank Aflossingsvrije Hypotheek",
    "LL004 Lloyds Bank Lineaire Hypotheek": "LL004 Lloyds Bank Lineaire Hypotheek",
    "LL005 Lloyds Bank Spaarhypotheek": "LL005 Lloyds Bank Spaarhypotheek",
    "LL006 Lloyds Bank Levenhypotheek": "LL006 Lloyds Bank Levenhypotheek",
    "LL007 Lloyds Bank Verduurzamingshypotheek": "LL007 Lloyds Bank Verduurzamingshypotheek",
    "LL501 BOS Annuïteiten hypotheek": "LL501 BOS Annuïteiten hypotheek",
    "LL502 BOS Unit Linked hypotheek": "LL502 BOS Unit Linked hypotheek",
    "LL503 BOS Aflossingsvrije hypotheek": "LL503 BOS Aflossingsvrije hypotheek",
    "LL504 BOS Spaar/Leven hypotheek": "LL504 BOS Spaar/Leven hypotheek",
    "LL505 BOS Effectenhypotheek": "LL505 BOS Effectenhypotheek",
    "LL506 BOS Leven hypotheek": "LL506 BOS Leven hypotheek",
    "LL507 BOS Unit Linked Special hypotheek": "LL507 BOS Unit Linked Special hypotheek",
    "LL508 BOS Universal Life hypotheek": "LL508 BOS Universal Life hypotheek",
    "LL509 BOS Spaarvast hypotheek": "LL509 BOS Spaarvast hypotheek",
    "LL510 BOS Lineair hypotheek": "LL510 BOS Lineair hypotheek",
    "LL511 BOS Hybride hypotheek": "LL511 BOS Hybride hypotheek",
    "LL512 BOS Verduurzamingshypotheek": "LL512 BOS Verduurzamingshypotheek",
    "LT001 Lot annuïteiten hypotheek": "LT001 Lot annuïteiten hypotheek",
    "LT002 Lot lineaire hypotheek": "LT002 Lot lineaire hypotheek",
    "LT003 Lot aflossingsvrije hypotheek": "LT003 Lot aflossingsvrije hypotheek",
    "LT004 Lot Duurzaamheidsleningdeel": "LT004 Lot Duurzaamheidsleningdeel",
    "ME001 Merius Annuïteit": "ME001 Merius Annuïteit",
    "ME002 Merius Lineair": "ME002 Merius Lineair",
    "ME003 Merius Aflossingsvrij": "ME003 Merius Aflossingsvrij",
    "MT001 Aflossingsvrij": "MT001 Aflossingsvrij",
    "MT002 Annuiteit": "MT002 Annuiteit",
    "MT003 Lineair": "MT003 Lineair",
    "MT004 Restschuld Annuiteit": "MT004 Restschuld Annuiteit",
    "MT005 Restschuld Lineair": "MT005 Restschuld Lineair",
    "MT006 Verduurzaam Annuïteit": "MT006 Verduurzaam Annuïteit",
    "MT007 Verduurzaam Lineair": "MT007 Verduurzaam Lineair",
    "MY001 Annuiteit": "MY001 Annuiteit",
    "MY004 Aflossingsvrij": "MY004 Aflossingsvrij",
    "MY010 Lineair": "MY010 Lineair",
    "NI011 NIBC Annuïteit": "NI011 NIBC Annuïteit",
    "NI012 NIBC Aflossingsvrij": "NI012 NIBC Aflossingsvrij",
    "NI013 NIBC Lineair": "NI013 NIBC Lineair",
    "NI014 NIBC Restschuld Lineair": "NI014 NIBC Restschuld Lineair",
    "NI015 NIBC Restschuld Annuïteit": "NI015 NIBC Restschuld Annuïteit",
    "NI018 NIBC Extra Annuïteit": "NI018 NIBC Extra Annuïteit",
    "NI019 NIBC Extra Aflossingsvrij": "NI019 NIBC Extra Aflossingsvrij",
    "NI020 NIBC Extra Lineair": "NI020 NIBC Extra Lineair",
    "NN001 Optimaal Spaarhypotheek": "NN001 Optimaal Spaarhypotheek",
    "NN002 Spaarhypotheek": "NN002 Spaarhypotheek",
    "NN003 Fondsenhypotheek": "NN003 Fondsenhypotheek",
    "NN004 Levenhypotheek": "NN004 Levenhypotheek",
    "NN006 Aflossingsvrije hypotheek": "NN006 Aflossingsvrije hypotheek",
    "NN007 Annuïtaire hypotheek": "NN007 Annuïtaire hypotheek",
    "NN008 Lineaire hypotheek": "NN008 Lineaire hypotheek",
    "NN012 BankSpaar Plus hypotheek": "NN012 BankSpaar Plus hypotheek",
    "NX001 Annuïteit": "NX001 Annuïteit",
    "NX002 Aflossingsvrij": "NX002 Aflossingsvrij",
    "NX003 Lineair": "NX003 Lineair",
    "OG001 Overwaarde Hypotheek": "OG001 Overwaarde Hypotheek",
    "OG002 Overwaarde Hypotheek periodiek": "OG002 Overwaarde Hypotheek periodiek",
    "OO001 SKP Aflossingsvrije hypotheek": "OO001 SKP Aflossingsvrije hypotheek",
    "OO002 SKP Annuïtaire hypotheek": "OO002 SKP Annuïtaire hypotheek",
    "OO003 SKP Levenhypotheek": "OO003 SKP Levenhypotheek",
    "OO004 SKP Spaarhypotheek": "OO004 SKP Spaarhypotheek",
    "OO005  SKP Beleggershypotheek": "OO005  SKP Beleggershypotheek",
    "OO006 SKP Flex Spaar Hypotheek": "OO006 SKP Flex Spaar Hypotheek",
    "OO007 SKP Overbruggingshypotheek": "OO007 SKP Overbruggingshypotheek",
    "OO008 SKP Lineaire Hypotheek": "OO008 SKP Lineaire Hypotheek",
    "OR001 Annuïteit": "OR001 Annuïteit",
    "OR002 Aflossingsvrij": "OR002 Aflossingsvrij",
    "OR003 Lineair": "OR003 Lineair",
    "OV001 Obvion Aflossingsvrije hypotheek": "OV001 Obvion Aflossingsvrije hypotheek",
    "OV002 Obvion Annuïteitenhypotheek": "OV002 Obvion Annuïteitenhypotheek",
    "OV003 Obvion Levenhypotheek": "OV003 Obvion Levenhypotheek",
    "OV004 Obvion Levenhypotheek met beleggingsrekening": "OV004 Obvion Levenhypotheek met beleggingsrekening",
    "OV005 Obvion Lineaire hypotheek": "OV005 Obvion Lineaire hypotheek",
    "OV010 Obvion Spaarhypotheek": "OV010 Obvion Spaarhypotheek",
    "OV013 Obvion SpaarGerusthypotheek": "OV013 Obvion SpaarGerusthypotheek",
    "OV014 Obvion Restschuld Annuïtair": "OV014 Obvion Restschuld Annuïtair",
    "OV015 Obvion Restschuld Lineair": "OV015 Obvion Restschuld Lineair",
    "OV016 Obvion Annuïteiten EPC 0.4": "OV016 Obvion Annuïteiten EPC 0.4",
    "OV017 Obvion Lineair EPC 0.4": "OV017 Obvion Lineair EPC 0.4",
    "OV018 Obvion Aflossingsvrij EPC 0.4": "OV018 Obvion Aflossingsvrij EPC 0.4",
    "PP001 Aflossingsvrije hypotheek": "PP001 Aflossingsvrije hypotheek",
    "PP002 Annuïteiten hypotheek": "PP002 Annuïteiten hypotheek",
    "PP003 Lineaire hypotheek": "PP003 Lineaire hypotheek",
    "PP004 Levenhypotheek": "PP004 Levenhypotheek",
    "PP005 Spaar-optie-hypotheek": "PP005 Spaar-optie-hypotheek",
    "RA003 Reaal Aflossingvrije Hypotheek": "RA003 Reaal Aflossingvrije Hypotheek",
    "RA004 Reaal Annuïteiten Hypotheek": "RA004 Reaal Annuïteiten Hypotheek",
    "RA007 Reaal Lineaire Hypotheek": "RA007 Reaal Lineaire Hypotheek",
    "RB001 Rabobank Annuïteitenhypotheek": "RB001 Rabobank Annuïteitenhypotheek",
    "RB002 Rabobank Lineaire Hypotheek": "RB002 Rabobank Lineaire Hypotheek",
    "RB003 Rabobank Aflossingsvrije hypotheek": "RB003 Rabobank Aflossingsvrije hypotheek",
    "RB004 Rabo OpbouwHypotheek Sparen": "RB004 Rabo OpbouwHypotheek Sparen",
    "RB005 Rabobank KeuzePlus Hypotheek": "RB005 Rabobank KeuzePlus Hypotheek",
    "RB006 Rabo Groenhypotheek": "RB006 Rabo Groenhypotheek",
    "RB007 Rabobank Annuïteit met restschuld": "RB007 Rabobank Annuïteit met restschuld",
    "RB008 Rabobank Lineair met restschuld": "RB008 Rabobank Lineair met restschuld",
    "RB009 Rabobank Aflossingsvrije Hypotheek (zonder einddatum)": "RB009 Rabobank Aflossingsvrije Hypotheek (zonder einddatum)",
    "RB010 Rabobank Aflossingsvrije Hypotheek (OWP)": "RB010 Rabobank Aflossingsvrije Hypotheek (OWP)",
    "RB011 Hypotheek met Gemengde Verzekering": "RB011 Hypotheek met Gemengde Verzekering",
    "RB012 OpMaatHypotheek": "RB012 OpMaatHypotheek",
    "RB013 SpaarOptimaalHypotheek": "RB013 SpaarOptimaalHypotheek",
    "RB015 SpaarZekerHypotheek": "RB015 SpaarZekerHypotheek",
    "RB016 Rabobank Annuïteiten Hypotheek verhuurde woning": "RB016 Rabobank Annuïteiten Hypotheek verhuurde woning",
    "RB017 Rabobank Lineaire Hypotheek verhuurde woning": "RB017 Rabobank Lineaire Hypotheek verhuurde woning",
    "RF001 Robuust Aflossingsvrij": "RF001 Robuust Aflossingsvrij",
    "RF002 Robuust Annuïteit": "RF002 Robuust Annuïteit",
    "RF003 Robuust Lineair": "RF003 Robuust Lineair",
    "RG101 Budget Beleggingshypotheek": "RG101 Budget Beleggingshypotheek",
    "RG102 Budget Spaarhypotheek (REAAL)": "RG102 Budget Spaarhypotheek (REAAL)",
    "RG103 Budget Aflossingsvrije hypotheek": "RG103 Budget Aflossingsvrije hypotheek",
    "RG104 Budget Liniaire hypotheek": "RG104 Budget Liniaire hypotheek",
    "RG105 Budget Annuitaire hypotheek": "RG105 Budget Annuitaire hypotheek",
    "RG106 Budget Spaarhypotheek (AXA)": "RG106 Budget Spaarhypotheek (AXA)",
    "RG107 Budget Aflossingsvrij/Levenhypotheek": "RG107 Budget Aflossingsvrij/Levenhypotheek",
    "RG108 Budget Spaarrekeninghypotheek": "RG108 Budget Spaarrekeninghypotheek",
    "RG109 Budget Beleggingsrekening Hypotheek": "RG109 Budget Beleggingsrekening Hypotheek",
    "RG110 Regiobank Budget Restschuldfinanciering": "RG110 Regiobank Budget Restschuldfinanciering",
    "RG111 Duurzaam Wonen Annuitair": "RG111 Duurzaam Wonen Annuitair",
    "RG112 Duurzaam Wonen Lineair": "RG112 Duurzaam Wonen Lineair",
    "RG201 RegioBank Bespaarhypotheek Aflossingsvrij": "RG201 RegioBank Bespaarhypotheek Aflossingsvrij",
    "RG202 RegioBank Bespaarhypotheek Annuitair": "RG202 RegioBank Bespaarhypotheek Annuitair",
    "RG203 RegioBank Bespaarhypotheek Lineair": "RG203 RegioBank Bespaarhypotheek Lineair",
    "SF001 Start Lineair": "SF001 Start Lineair",
    "SF002 Start Annuiteit": "SF002 Start Annuiteit",
    "SM001 Someday aflossingsvrij": "SM001 Someday aflossingsvrij",
    "SN005 SNS Extra Ruimte Hypotheek": "SN005 SNS Extra Ruimte Hypotheek",
    "SN101 SNS Budget Rendement Hypotheek": "SN101 SNS Budget Rendement Hypotheek",
    "SN103 SNS Budget Spaar Hypotheek Plus": "SN103 SNS Budget Spaar Hypotheek Plus",
    "SN106 SNS Budget Aflossingsvrije Hypotheek": "SN106 SNS Budget Aflossingsvrije Hypotheek",
    "SN107 SNS Budget Lineaire Hypotheek": "SN107 SNS Budget Lineaire Hypotheek",
    "SN108 SNS Budget Annuitaire Hypotheek": "SN108 SNS Budget Annuitaire Hypotheek",
    "SN112 SNS Budget Afl.Vrij met Verpande Verz.": "SN112 SNS Budget Afl.Vrij met Verpande Verz.",
    "SN113 SNS Budget Spaarrekening Hypotheek": "SN113 SNS Budget Spaarrekening Hypotheek",
    "SN114 SNS Budget Beleggingsrekening Hypotheek": "SN114 SNS Budget Beleggingsrekening Hypotheek",
    "SN115 SNS Budget Restschuldfinanciering": "SN115 SNS Budget Restschuldfinanciering",
    "SN116 Duurzaam Wonen Annuitair": "SN116 Duurzaam Wonen Annuitair",
    "SN117 Duurzaam Wonen Lineair": "SN117 Duurzaam Wonen Lineair",
    "SN201 SNS Bespaarhypotheek Aflossingsvrij": "SN201 SNS Bespaarhypotheek Aflossingsvrij",
    "SN202 SNS Bespaarhypotheek Annuitair": "SN202 SNS Bespaarhypotheek Annuitair",
    "SN203 SNS Bespaarhypotheek Lineair": "SN203 SNS Bespaarhypotheek Lineair",
    "SY001 Syntrus Achmea Aflossingsvrij": "SY001 Syntrus Achmea Aflossingsvrij",
    "SY002 Syntrus Achmea Annuïteit": "SY002 Syntrus Achmea Annuïteit",
    "SY003 Syntrus Achmea Leven": "SY003 Syntrus Achmea Leven",
    "SY004 Syntrus Achmea Lineair": "SY004 Syntrus Achmea Lineair",
    "SY005 Syntrus Achmea Spaar": "SY005 Syntrus Achmea Spaar",
    "SY006 Syntrus Achmea Groen Annuïteit": "SY006 Syntrus Achmea Groen Annuïteit",
    "SY007 Syntrus Achmea Groen Lineair": "SY007 Syntrus Achmea Groen Lineair",
    "TB001 Annuïteit": "TB001 Annuïteit",
    "TB002 Lineair": "TB002 Lineair",
    "TB003 Aflossingsvrij": "TB003 Aflossingsvrij",
    "TH001 Annuïteit": "TH001 Annuïteit",
    "TH002 Aflosvrij": "TH002 Aflosvrij",
    "TH003 Lineair": "TH003 Lineair",
    "TL001 Tellius Hypotheken Aflossingsvrij": "TL001 Tellius Hypotheken Aflossingsvrij",
    "TL002 Tellius Hypotheken Annuïteit": "TL002 Tellius Hypotheken Annuïteit",
    "TL003 Tellius Hypotheken Lineair": "TL003 Tellius Hypotheken Lineair",
    "VA001 Aflossingsvrij": "VA001 Aflossingsvrij",
    "VA002 Annuïteit": "VA002 Annuïteit",
    "VA003 Lineair": "VA003 Lineair",
    "VE001 Venn Annuïteiten Hypotheek": "VE001 Venn Annuïteiten Hypotheek",
    "VE002 Venn Lineaire Hypotheek": "VE002 Venn Lineaire Hypotheek",
    "VE003 Venn Aflossingsvrije Hypotheek": "VE003 Venn Aflossingsvrije Hypotheek",
    "VE004 Venn Gemakkelijk Groen Hypotheek": "VE004 Venn Gemakkelijk Groen Hypotheek",
    "VF001 Vandaag Hypotheek Aflossingsvrij": "VF001 Vandaag Hypotheek Aflossingsvrij",
    "VF002 Vandaag Hypotheek Overwaarde": "VF002 Vandaag Hypotheek Overwaarde",
    "WF001 Aflossingsvrije hypotheek": "WF001 Aflossingsvrije hypotheek",
    "WF002 Annuiteitenhypotheek": "WF002 Annuiteitenhypotheek",
    "WF005 Levenhypotheek": "WF005 Levenhypotheek",
    "WF006 Lineaire hypotheek": "WF006 Lineaire hypotheek",
    "WF008 Spaarhypotheek": "WF008 Spaarhypotheek",
    "WF012 Beleggingshypotheek": "WF012 Beleggingshypotheek",
    "WF013 Hybride Hypotheek": "WF013 Hybride Hypotheek",
    "WF015 Bankspaarhypotheek": "WF015 Bankspaarhypotheek",
    "WF016 Restschuld Annuïtair": "WF016 Restschuld Annuïtair",
    "WF017 Restschuld Lineair": "WF017 Restschuld Lineair",
    "WF018 Woongenot Aflossingsvrij": "WF018 Woongenot Aflossingsvrij",
    "WF019 Woongenot Annuïteit": "WF019 Woongenot Annuïteit",
    "WF020 Woongenot Lineair": "WF020 Woongenot Lineair",
    "WF021 Woongenot Leven": "WF021 Woongenot Leven",
    "WF022 Woongenot Bankspaar": "WF022 Woongenot Bankspaar",
    "WF023 Woongenot Beleggers": "WF023 Woongenot Beleggers",
    "WF024 Woongenot Spaar": "WF024 Woongenot Spaar",
    "WF025 Woongenot Hybride": "WF025 Woongenot Hybride",
    "WF026 Woongenot Restschuld Annuïtair ": "WF026 Woongenot Restschuld Annuïtair ",
    "WF027 Woongenot Restschuld Lineair": "WF027 Woongenot Restschuld Lineair",
    "WF028 Woningverhuur Annuïteit": "WF028 Woningverhuur Annuïteit",
    "WF029 Woningverhuur Lineair": "WF029 Woningverhuur Lineair",
    "WF030 Woningverhuur Aflossingsvrij": "WF030 Woningverhuur Aflossingsvrij",
    "WF031 Krediet Hypotheek": "WF031 Krediet Hypotheek",
    "WF032 Groen Annuïtair": "WF032 Groen Annuïtair",
    "WF033 Groen Lineair": "WF033 Groen Lineair",
    "WF034 Woongenot Groen Annuïtair": "WF034 Woongenot Groen Annuïtair",
    "WF035 Woongenot Groen Lineair": "WF035 Woongenot Groen Lineair",
    "WF036 Woningverhuur Groen Annuïtair": "WF036 Woningverhuur Groen Annuïtair",
    "WF037 Woningverhuur Groen Lineair": "WF037 Woningverhuur Groen Lineair",
    "WX001 Woonnu Aflossingsvrij": "WX001 Woonnu Aflossingsvrij",
    "WX002 Woonnu Annuïtair": "WX002 Woonnu Annuïtair",
    "WX003 Woonnu Lineair": "WX003 Woonnu Lineair",
});
export const CodeDekkingMijType = Object.freeze({
    "AU002 ASR Risicoverzekering Gelijkblijvend": "AU002 ASR Risicoverzekering Gelijkblijvend",
    "AU003 ASR Risicoverzekering Annuitair dalend": "AU003 ASR Risicoverzekering Annuitair dalend",
    "AU004 ASR Risicoverzekering Lineair Dalend": "AU004 ASR Risicoverzekering Lineair Dalend",
    "AZ001 Allianz Design Spaarhypotheekverzekering": "AZ001 Allianz Design Spaarhypotheekverzekering",
    "AZ004 Allianz Plus Hypotheekrekening": "AZ004 Allianz Plus Hypotheekrekening",
    "AZ005 Allianz Plus Rekening": "AZ005 Allianz Plus Rekening",
    "AZ010 Allianz Design Risico (uitgefaseerd, niet meer gebruiken)": "AZ010 Allianz Design Risico (uitgefaseerd, niet meer gebruiken)",
    "AZ011 Allianz Overlijdensrisicoverzekering": "AZ011 Allianz Overlijdensrisicoverzekering",
    "FH001 Hybride Extra": "FH001 Hybride Extra",
    "HQ001  SpaarBeter Verzekering": "HQ001  SpaarBeter Verzekering",
    "HQ002 Solide Koers Beleggingsrekening": "HQ002 Solide Koers Beleggingsrekening",
    "HT001 Spaar Toekomst Verzekering": "HT001 Spaar Toekomst Verzekering",
    "HT003 Zeker Weten Spaarverzekering": "HT003 Zeker Weten Spaarverzekering",
    "HT004 Hypotrust Trend Spaarverzekering": "HT004 Hypotrust Trend Spaarverzekering",
    "HT005 Hypotrust Spaar OK Spaarverzekering": "HT005 Hypotrust Spaar OK Spaarverzekering",
    "HT006 Hypotrust OK Spaarverzekering": "HT006 Hypotrust OK Spaarverzekering",
    "OO001 Solide Koers Spaarverzekering": "OO001 Solide Koers Spaarverzekering",
    "OO002 Solide Koers beleggersverzekering": "OO002 Solide Koers beleggersverzekering",
    "OO003 Solide Koers Flex Spaarverzekering": "OO003 Solide Koers Flex Spaarverzekering",
    "OO004 Levensverzekering": "OO004 Levensverzekering",
});
export const CodeFinancieleDekkingType = Object.freeze({
    "01 levensverzekering": "01 levensverzekering",
    "04 (zelfstandige) risicoverzekering": "04 (zelfstandige) risicoverzekering",
    "06 Erf/lijfrente": "06 Erf/lijfrente",
    "07 Spaarverzekering": "07 Spaarverzekering",
    "08 Beleggingsverzekering": "08 Beleggingsverzekering",
    "09 Hybride verzekering": "09 Hybride verzekering",
});
export const CodeHypotheekOptiesMijType = Object.freeze({
    "RB001 Betaalpakketkorting": "RB001 Betaalpakketkorting",
    "RB002 Duurzaamheidskorting": "RB002 Duurzaamheidskorting",
    "RB003 Betaalpakketkorting i.c.m. Duurzaamheidskorting": "RB003 Betaalpakketkorting i.c.m. Duurzaamheidskorting",
});
export const CodeLeningDeelType = Object.freeze({
    "1 Nieuw": "1 Nieuw",
    "2 Meeneem (zelfde geldgever, ander object)": "2 Meeneem (zelfde geldgever, ander object)",
    "3 Doorgeef (Zelfde geldgever, zelfde  object, andere hypotheekgever)": "3 Doorgeef (Zelfde geldgever, zelfde  object, andere hypotheekgever)",
    "4 Omzetting (andere aflosvorm)": "4 Omzetting (andere aflosvorm)",
});
export const CodeLeningMijType = Object.freeze({
    "AA001 ABN AMRO Woninghypotheek": "AA001 ABN AMRO Woninghypotheek",
    "AA010 ABN AMRO Budget Hypotheek": "AA010 ABN AMRO Budget Hypotheek",
    "AA016 ABN AMRO Private Banking Woning Hypotheek": "AA016 ABN AMRO Private Banking Woning Hypotheek",
    "AA018 ABN AMRO Private Banking Budget Hypotheek": "AA018 ABN AMRO Private Banking Budget Hypotheek",
    "AB001 ABP Hypotheek": "AB001 ABP Hypotheek",
    "AE011 Aegon Hypotheek": "AE011 Aegon Hypotheek",
    "AK001 ASN Hypotheek": "AK001 ASN Hypotheek",
    "AK002 Bespaarhypotheek": "AK002 Bespaarhypotheek",
    "AQ001 Attens Hypotheek": "AQ001 Attens Hypotheek",
    "AR001 Argenta Hypotheek": "AR001 Argenta Hypotheek",
    "AR002 Argenta Light Hypotheek": "AR002 Argenta Light Hypotheek",
    "AR003 Argenta Special Line Hypotheek": "AR003 Argenta Special Line Hypotheek",
    "AR004 Argenta Spectrum Hypotheek": "AR004 Argenta Spectrum Hypotheek",
    "AR005 Argenta Spectrum Annuiteit Extra Hypotheek": "AR005 Argenta Spectrum Annuiteit Extra Hypotheek",
    "AU001 ASR WelThuis Hypotheek": "AU001 ASR WelThuis Hypotheek",
    "AU002 ASR DigiThuis Hypotheek": "AU002 ASR DigiThuis Hypotheek",
    "AW001 Abel hypotheken": "AW001 Abel hypotheken",
    "AZ001 Allianz & BNP Paribas Hypotheek": "AZ001 Allianz & BNP Paribas Hypotheek",
    "AZ002 Allianz Hypotheek": "AZ002 Allianz Hypotheek",
    "BB001 bijBouwe Hypotheek": "BB001 bijBouwe Hypotheek",
    "BB002 bijBouwe Online Hypotheek ": "BB002 bijBouwe Online Hypotheek ",
    "BB003 bijBouwe Vooruit Hypotheek": "BB003 bijBouwe Vooruit Hypotheek",
    "BL001 BLG Hypotheek": "BL001 BLG Hypotheek",
    "BL002 BLG Bespaarhypotheek": "BL002 BLG Bespaarhypotheek",
    "BL003 BLG Recreatiehypotheek": "BL003 BLG Recreatiehypotheek",
    "BN001 UCB Hypotheek": "BN001 UCB Hypotheek",
    "BN002 UCB Excellence Hypotheek": "BN002 UCB Excellence Hypotheek",
    "BN003 Beta Plus Hypotheek": "BN003 Beta Plus Hypotheek",
    "BN004 UCB Excellence Voordeel Hypotheek": "BN004 UCB Excellence Voordeel Hypotheek",
    "BN005 UCB PLUS+UNIEK Hypotheek": "BN005 UCB PLUS+UNIEK Hypotheek",
    "BN006 Liberté Hypotheek": "BN006 Liberté Hypotheek",
    "BN007 Liberté Voordeel Hypotheek": "BN007 Liberté Voordeel Hypotheek",
    "BN008 Confidence Hypotheek": "BN008 Confidence Hypotheek",
    "BN009 Confidence Voordeel Hypotheek": "BN009 Confidence Voordeel Hypotheek",
    "BN011 PLUS+UNIEK Voordeel Hypotheek": "BN011 PLUS+UNIEK Voordeel Hypotheek",
    "BN012 Excellence Hypotheek": "BN012 Excellence Hypotheek",
    "BN014 WoonGerust hypotheek": "BN014 WoonGerust hypotheek",
    "BN015 WoonGerust+ hypotheek": "BN015 WoonGerust+ hypotheek",
    "BN016 Hypotheekshop Netto Plus (BNPParibasPF)": "BN016 Hypotheekshop Netto Plus (BNPParibasPF)",
    "BN017 BNP Paribas Hypotheek": "BN017 BNP Paribas Hypotheek",
    "BN018 BNP Paribas Hypotheek Deux": "BN018 BNP Paribas Hypotheek Deux",
    "BN019 BNP Paribas Hypotheek Trois": "BN019 BNP Paribas Hypotheek Trois",
    "BN020 BNP Paribas Hypotheek Quatre": "BN020 BNP Paribas Hypotheek Quatre",
    "BO001 Bank of Scotland Hypotheek": "BO001 Bank of Scotland Hypotheek",
    "BO002 Bank of Scotland Economy Hypotheek": "BO002 Bank of Scotland Economy Hypotheek",
    "BO003 Bank of Scotland Easy Hypotheek": "BO003 Bank of Scotland Easy Hypotheek",
    "BO004 Bank of Scotland Budget Hypotheek": "BO004 Bank of Scotland Budget Hypotheek",
    "BQ001 bunq easy mortgage": "BQ001 bunq easy mortgage",
    "BS001 Bouwsteen Hypotheek": "BS001 Bouwsteen Hypotheek",
    "CB001 Centraal Beheer Thuis Hypotheek": "CB001 Centraal Beheer Thuis Hypotheek",
    "CB002 Centraal Beheer Basis Lijn": "CB002 Centraal Beheer Basis Lijn",
    "CB003 Centraal Beheer Leef Hypotheek": "CB003 Centraal Beheer Leef Hypotheek",
    "CC001 Credo Hypotheek": "CC001 Credo Hypotheek",
    "CL001 Colibri Startershypotheek": "CL001 Colibri Startershypotheek",
    "CW001 Clarian Wonen Hypotheek": "CW001 Clarian Wonen Hypotheek",
    "DD001 Dynamic Lekker Wonen Hypotheek": "DD001 Dynamic Lekker Wonen Hypotheek",
    "DY001 Dynamic Verhuurhypotheek": "DY001 Dynamic Verhuurhypotheek",
    "FH004 Florius Verzilver Hypotheek": "FH004 Florius Verzilver Hypotheek",
    "FH007 Florius Profijt Drie+Drie (0% afsluitkosten)": "FH007 Florius Profijt Drie+Drie (0% afsluitkosten)",
    "FH009 Florius Profijt Twaalf (0% afsluitkosten)": "FH009 Florius Profijt Twaalf (0% afsluitkosten)",
    "FH010 Florius Compleet Hypotheek": "FH010 Florius Compleet Hypotheek",
    "GH001 Groene Hart Hypotheek": "GH001 Groene Hart Hypotheek",
    "HQ001 HQ": "HQ001 HQ",
    "HQ002 HQ Profijt": "HQ002 HQ Profijt",
    "HQ003 HQ VoordeelExtra": "HQ003 HQ VoordeelExtra",
    "HT001 Hypotrust": "HT001 Hypotrust",
    "HT002 Hypotrust Profijt": "HT002 Hypotrust Profijt",
    "HT007 Zeker Weten Hypotheek": "HT007 Zeker Weten Hypotheek",
    "HT008 Zeker Weten Hypotheek Profijt": "HT008 Zeker Weten Hypotheek Profijt",
    "HT011 Zeker Weten Budgethypotheek": "HT011 Zeker Weten Budgethypotheek",
    "HT013 Hypotrust Budget": "HT013 Hypotrust Budget",
    "HT014 Hypotrust Trend": "HT014 Hypotrust Trend",
    "HT016 Hypotrust OK Hypotheek": "HT016 Hypotrust OK Hypotheek",
    "HT017 Hypotrust Goede Start Hypotheek": "HT017 Hypotrust Goede Start Hypotheek",
    "HT018 Hypotrust Woon Bewust Hypotheek": "HT018 Hypotrust Woon Bewust Hypotheek",
    "HT019 Hypotrust ELAN Hypotheek": "HT019 Hypotrust ELAN Hypotheek",
    "HT020 Hypotrust Comfort Standaard": "HT020 Hypotrust Comfort Standaard",
    "HT021 Hypotrust Comfort Profijt": "HT021 Hypotrust Comfort Profijt",
    "HT022 Hypotrust ELAN Plus Hypotheek": "HT022 Hypotrust ELAN Plus Hypotheek",
    "HT023 Hypotrust Vrij Leven Hypotheek": "HT023 Hypotrust Vrij Leven Hypotheek",
    "HV001 HollandWoont Hypotheek": "HV001 HollandWoont Hypotheek",
    "IM001 Impact Hypotheek": "IM001 Impact Hypotheek",
    "IN001 Reguliere hypotheek": "IN001 Reguliere hypotheek",
    "IN003 Watervilla hypotheek": "IN003 Watervilla hypotheek",
    "IN007 Reguliere hypotheek met Dagrente": "IN007 Reguliere hypotheek met Dagrente",
    "IQ001 IQWOON Hypotheek": "IQ001 IQWOON Hypotheek",
    "KB001 Knab Hypotheek": "KB001 Knab Hypotheek",
    "LK001 Van Lanschot Kempen Hypotheek": "LK001 Van Lanschot Kempen Hypotheek",
    "LL001 Lloyds Bank Hypotheek": "LL001 Lloyds Bank Hypotheek",
    "LL002 Lloyds Bank Verhuurhypotheek": "LL002 Lloyds Bank Verhuurhypotheek",
    "LL499 Lloyds Bank Online Hypotheek": "LL499 Lloyds Bank Online Hypotheek",
    "LL501 Bank of Scotland Hypotheek": "LL501 Bank of Scotland Hypotheek",
    "LL502 Bank of Scotland Economy Hypotheek": "LL502 Bank of Scotland Economy Hypotheek",
    "LL503 Bank of Scotland Easy Hypotheek": "LL503 Bank of Scotland Easy Hypotheek",
    "LL504 Bank of Scotland Budget Hypotheek": "LL504 Bank of Scotland Budget Hypotheek",
    "LT001 Lot Hypotheek": "LT001 Lot Hypotheek",
    "ME001 Merius Hypotheek": "ME001 Merius Hypotheek",
    "MT001 Munt Hypotheek": "MT001 Munt Hypotheek",
    "MT002 Munt Simpel Overstap Hypotheek": "MT002 Munt Simpel Overstap Hypotheek",
    "MY001 MoneYou": "MY001 MoneYou",
    "NI005 NIBC Hypotheek": "NI005 NIBC Hypotheek",
    "NI007 NIBC Extra": "NI007 NIBC Extra",
    "NI008 NIBC Investeringshypotheek": "NI008 NIBC Investeringshypotheek",
    "NN004 Reguliere Hypotheek": "NN004 Reguliere Hypotheek",
    "NN007 Verhuurhypotheek": "NN007 Verhuurhypotheek",
    "NX003 Neo Hypotheek": "NX003 Neo Hypotheek",
    "OG001 ZilverHuis Hypotheek": "OG001 ZilverHuis Hypotheek",
    "OO001 SKP": "OO001 SKP",
    "OO003 SKP Profijt": "OO003 SKP Profijt",
    "OR001 Woonboot Hypotheek": "OR001 Woonboot Hypotheek",
    "OV001 Obvion Hypotheek": "OV001 Obvion Hypotheek",
    "OV003 Obvion Basis Hypotheek": "OV003 Obvion Basis Hypotheek",
    "OV004 StartGerusthypotheek met Starters Renteregeling": "OV004 StartGerusthypotheek met Starters Renteregeling",
    "OV005 Obvion Compact Hypotheek": "OV005 Obvion Compact Hypotheek",
    "OV006 StartGerusthypotheek Light met Starters Renteregeling": "OV006 StartGerusthypotheek Light met Starters Renteregeling",
    "OV007 Obvion Duurzaam Wonen Hypotheek": "OV007 Obvion Duurzaam Wonen Hypotheek",
    "OV009 Obvion Woon Hypotheek": "OV009 Obvion Woon Hypotheek",
    "PP001 Philips Pensioenfonds hypotheek": "PP001 Philips Pensioenfonds hypotheek",
    "RA010 Reaal Lekker Wonen Hypotheek": "RA010 Reaal Lekker Wonen Hypotheek",
    "RB001 Rabobank Hypotheek": "RB001 Rabobank Hypotheek",
    "RB002 Rabo BasisHypotheek": "RB002 Rabo BasisHypotheek",
    "RF001 Robuust Hypotheek": "RF001 Robuust Hypotheek",
    "RG001 Budgethypotheek": "RG001 Budgethypotheek",
    "RG002 RegioBank Bespaarhypotheek": "RG002 RegioBank Bespaarhypotheek",
    "SF001 Start Hypotheek": "SF001 Start Hypotheek",
    "SM001 Someday Overwaarde Hypotheek": "SM001 Someday Overwaarde Hypotheek",
    "SN002 SNS Bespaarhypotheek": "SN002 SNS Bespaarhypotheek",
    "SN007 SNS Budget Hypotheek": "SN007 SNS Budget Hypotheek",
    "SY001 Syntrus Achmea Comforthypotheek": "SY001 Syntrus Achmea Comforthypotheek",
    "SY002 Syntrus Achmea Basishypotheek": "SY002 Syntrus Achmea Basishypotheek",
    "TB001 Triodos Hypotheek": "TB001 Triodos Hypotheek",
    "TH002 Tulp Optimaal Hypotheek": "TH002 Tulp Optimaal Hypotheek",
    "TH003 Tulp Hypotheek": "TH003 Tulp Hypotheek",
    "TH004 Tulp Compleet Hypotheek": "TH004 Tulp Compleet Hypotheek",
    "TH005 Tulp Riant Hypotheek": "TH005 Tulp Riant Hypotheek",
    "TL001 Tellius Toekomstvast Hypotheek": "TL001 Tellius Toekomstvast Hypotheek",
    "VA001 Vista Hypotheek": "VA001 Vista Hypotheek",
    "VE001 Venn Hypotheek": "VE001 Venn Hypotheek",
    "VF001 Vandaag Hypotheek": "VF001 Vandaag Hypotheek",
    "WF001 Woonfonds Hypotheek": "WF001 Woonfonds Hypotheek",
    "WF012 Woonfonds Woongenot Hypotheek": "WF012 Woonfonds Woongenot Hypotheek",
    "WF013 Woonfonds Woningverhuur Hypotheek": "WF013 Woonfonds Woningverhuur Hypotheek",
    "WX001 Woonnu Hypotheek": "WX001 Woonnu Hypotheek",
});
export const CodeLopendeDekkingType = Object.freeze({
    "01 KEW": "01 KEW",
    "02 SEW": "02 SEW",
    "03 BEW": "03 BEW",
});
export const CodeRenteMijType = Object.freeze({
    "AE001 Vaste rente dagrente": "AE001 Vaste rente dagrente",
    "AE002 Vaste rente offerterente": "AE002 Vaste rente offerterente",
    "AE003 Variabele rente": "AE003 Variabele rente",
    "AK001 ASN Rentevast": "AK001 ASN Rentevast",
    "AK002 ASN Variabel": "AK002 ASN Variabel",
    "AR001 Variabele Rente": "AR001 Variabele Rente",
    "AR002 Vaste Rente": "AR002 Vaste Rente",
    "AZ001 Standaard voorwaarde": "AZ001 Standaard voorwaarde",
    "AZ002 Rentebedenktijd": "AZ002 Rentebedenktijd",
    "AZ003 Variabele rente": "AZ003 Variabele rente",
    "BB001 bijBouwe Vaste Rente": "BB001 bijBouwe Vaste Rente",
    "BB002 bijBouwe Variabele Rente": "BB002 bijBouwe Variabele Rente",
    "BB003 bijBouwe Online Vaste Rente": "BB003 bijBouwe Online Vaste Rente",
    "BB004 bijBouwe Online Variabele Rente": "BB004 bijBouwe Online Variabele Rente",
    "BL001 BLG Rentevast": "BL001 BLG Rentevast",
    "BL003 BLG Variabele rente": "BL003 BLG Variabele rente",
    "BL005 BLG Plafondrente": "BL005 BLG Plafondrente",
    "BL007 BLG Middelrente": "BL007 BLG Middelrente",
    "CB001 Centraal Beheer Thuis Hypotheek Vaste Rente": "CB001 Centraal Beheer Thuis Hypotheek Vaste Rente",
    "CB002 Centraal Beheer Thuis Hypotheek Variabele Rente": "CB002 Centraal Beheer Thuis Hypotheek Variabele Rente",
    "CB003 Centraal Beheer Basis Lijn Vaste Rente": "CB003 Centraal Beheer Basis Lijn Vaste Rente",
    "CB004 Centraal Beheer Basis Lijn Variabele Rente": "CB004 Centraal Beheer Basis Lijn Variabele Rente",
    "CB005 Centraal Beheer Leef Hypotheek Vaste Rente": "CB005 Centraal Beheer Leef Hypotheek Vaste Rente",
    "CB006 Centraal Beheer Leef Hypotheek Variabele Rente": "CB006 Centraal Beheer Leef Hypotheek Variabele Rente",
    "CW001 Clarian Wonen Vaste Rente": "CW001 Clarian Wonen Vaste Rente",
    "DY001 Dynamic Vaste Rente": "DY001 Dynamic Vaste Rente",
    "DY002 Dynamic Variabele Rente": "DY002 Dynamic Variabele Rente",
    "HQ001 Standaard voorwaarde": "HQ001 Standaard voorwaarde",
    "HQ003 Variabele rente": "HQ003 Variabele rente",
    "HT003 VR Variabele Rente": "HT003 VR Variabele Rente",
    "HT006 BP Budgetproduct": "HT006 BP Budgetproduct",
    "HT007 SP Standaard Product": "HT007 SP Standaard Product",
    "HT009 Hypotrust Trend": "HT009 Hypotrust Trend",
    "HT010 Hypotrust Spaar OK Vaste Rente": "HT010 Hypotrust Spaar OK Vaste Rente",
    "HT011 Hypotrust Spaar OK Variabele Rente": "HT011 Hypotrust Spaar OK Variabele Rente",
    "HT012 Hypotrust OK Vaste Rente": "HT012 Hypotrust OK Vaste Rente",
    "HT013 Hypotrust OK Variabele Rente": "HT013 Hypotrust OK Variabele Rente",
    "HT014 Hypotrust Goede Start Vaste Rente": "HT014 Hypotrust Goede Start Vaste Rente",
    "HT015 Hypotrust Woon Bewust Vaste Rente": "HT015 Hypotrust Woon Bewust Vaste Rente",
    "HT016 Hypotrust Profijt Vaste Rente": "HT016 Hypotrust Profijt Vaste Rente",
    "HT017 Hypotrust Profijt Variabele Rente": "HT017 Hypotrust Profijt Variabele Rente",
    "HT018 Hypotrust ELAN Vaste Rente": "HT018 Hypotrust ELAN Vaste Rente",
    "HT019 Hypotrust ELAN Variabele Rente": "HT019 Hypotrust ELAN Variabele Rente",
    "HT020 Hypotrust Comfort Standaard Vast": "HT020 Hypotrust Comfort Standaard Vast",
    "HT021 Hypotrust Comfort Standaard Variabel": "HT021 Hypotrust Comfort Standaard Variabel",
    "HT022 Hypotrust Comfort Profijt Vast": "HT022 Hypotrust Comfort Profijt Vast",
    "HT023 Hypotrust ELAN Plus Vaste Rente": "HT023 Hypotrust ELAN Plus Vaste Rente",
    "HT024 Hypotrust ELAN Plus Variabele Rente": "HT024 Hypotrust ELAN Plus Variabele Rente",
    "HT025 Hypotrust Vrij Leven Vaste Rente": "HT025 Hypotrust Vrij Leven Vaste Rente",
    "HV001 HollandWoont Vaste Rente": "HV001 HollandWoont Vaste Rente",
    "IN001 Middelrente": "IN001 Middelrente",
    "IN002 Restant Rentevaste Periode": "IN002 Restant Rentevaste Periode",
    "IN003 Actuele Rente": "IN003 Actuele Rente",
    "IQ001 IQWOON Vaste Rente": "IQ001 IQWOON Vaste Rente",
    "IQ002 IQWOON Variabele Rente": "IQ002 IQWOON Variabele Rente",
    "OO001 VR Variabele Rente": "OO001 VR Variabele Rente",
    "OO002 RA Rentebedenktijd achteraf": "OO002 RA Rentebedenktijd achteraf",
    "OO005 Vaste Rente": "OO005 Vaste Rente",
    "OV001 Flexibele rente": "OV001 Flexibele rente",
    "OV002 Variabele rente": "OV002 Variabele rente",
    "RF001 Robuust Vaste Rente": "RF001 Robuust Vaste Rente",
    "RF002 Robuust Variabele Rente": "RF002 Robuust Variabele Rente",
    "RG001 Rentevast": "RG001 Rentevast",
    "RG002 Rentedemper": "RG002 Rentedemper",
    "RG003 Variabele rente": "RG003 Variabele rente",
    "RG004 Plafondrente": "RG004 Plafondrente",
    "SN001 SNS Rentevast": "SN001 SNS Rentevast",
    "SN002 SNS Rentedemper": "SN002 SNS Rentedemper",
    "SN003 SNS Variabele Rente": "SN003 SNS Variabele Rente",
    "SN005 SNS Plafondrente": "SN005 SNS Plafondrente",
    "VA001 Vaste Rente": "VA001 Vaste Rente",
    "VA002 Variabele Rente": "VA002 Variabele Rente",
    "WF001 Vaste rente": "WF001 Vaste rente",
    "WF003 Kwaartaal-variabel": "WF003 Kwaartaal-variabel",
    "WF004 Woongenot Vaste Rente": "WF004 Woongenot Vaste Rente",
    "WF005 Woongenot Variabele Rente": "WF005 Woongenot Variabele Rente",
    "WF006 Woningverhuur Vaste Rente": "WF006 Woningverhuur Vaste Rente",
    "WF007 Woningverhuur Variabele Rente": "WF007 Woningverhuur Variabele Rente",
    "WF009 Krediethypotheek Maand Variabele Rente": "WF009 Krediethypotheek Maand Variabele Rente",
    "WX001 Woonnu Vaste Rente": "WX001 Woonnu Vaste Rente",
});
export const CodeUitkeringType = Object.freeze({
    "01 Lineair dalend": "01 Lineair dalend",
    "02 annuitair dalend": "02 annuitair dalend",
    "03 gelijkblijvend": "03 gelijkblijvend",
    "04 1-jarig (jaarlijks vast te stellen)": "04 1-jarig (jaarlijks vast te stellen)",
});
export const DataleverancierType = Object.freeze({
    "01 Calcasa": "01 Calcasa",
    "02 Ockto": "02 Ockto",
    "03 iWize": "03 iWize",
    "04 Vidua": "04 Vidua",
    "08 Datakeeper": "08 Datakeeper",
    "10 Veilig Ophalen": "10 Veilig Ophalen",
});
export const DekkingscodeType = Object.freeze({
    "01 Geen overlijdensdekking": "01 Geen overlijdensdekking",
    "05 110 % van de aanwezige fondswaarde": "05 110 % van de aanwezige fondswaarde",
    "07 Gelijkblijvend risicokapitaal": "07 Gelijkblijvend risicokapitaal",
    "08 Gelijkblijvend of 90 % fondswaarde": "08 Gelijkblijvend of 90 % fondswaarde",
    "10 Lineair dalend risicokapitaal": "10 Lineair dalend risicokapitaal",
});
export const EnergieKlasseType = Object.freeze({
    "01 A++": "01 A++",
    "02 A+": "02 A+",
    "03 A": "03 A",
    "04 B": "04 B",
    "05 C": "05 C",
    "06 D": "06 D",
    "07 E": "07 E",
    "08 F": "08 F",
    "09 G": "09 G",
    "10 A+++": "10 A+++",
    "11 A++++": "11 A++++",
    "14 A++++ (EP garantie)": "14 A++++ (EP garantie)",
    "90 Geen energielabel mogelijk": "90 Geen energielabel mogelijk",
    "91 Geen energielabel beschikbaar": "91 Geen energielabel beschikbaar",
});
export const ErfpachtconstructieOfKoperssteunAndersType = Object.freeze({
    "01 Koperssteun met vermogensrisico": "01 Koperssteun met vermogensrisico",
    "02 Erfpachtconstructie met vermogensrisico": "02 Erfpachtconstructie met vermogensrisico",
    "03 Koperssteun zonder vermogensrisico": "03 Koperssteun zonder vermogensrisico",
    "04 Erfpachtconstructie zonder vermogensrisico": "04 Erfpachtconstructie zonder vermogensrisico",
});
export const ExplainRedenType = Object.freeze({
    "01 Maatschappijspecifiek": "01 Maatschappijspecifiek",
    "02 Senioren verhuisregeling": "02 Senioren verhuisregeling",
    "03 Senioren tijdelijk tekort": "03 Senioren tijdelijk tekort",
    "04 Persoonlijk Budgetadvies NIBUD": "04 Persoonlijk Budgetadvies NIBUD",
    "05 Inkomen uit verpand vermogen": "05 Inkomen uit verpand vermogen",
    "06 Netto besteedbaar inkomen": "06 Netto besteedbaar inkomen",
    "07 Toekomstperspectief/Inkomensgroei": "07 Toekomstperspectief/Inkomensgroei",
    "08 Uit eigen vermogen inbrengen premiedepot, lopende premievrije polis of eerste inleg": "08 Uit eigen vermogen inbrengen premiedepot, lopende premievrije polis of eerste inleg",
    "09 Vrij beschikbaar vermogen": "09 Vrij beschikbaar vermogen",
    "10 Huidige woonlasten hoger dan nieuwe woonlasten": "10 Huidige woonlasten hoger dan nieuwe woonlasten",
    "11 Overig": "11 Overig",
});
export const FiscaalRegimeFGVType = Object.freeze({
    "01 Pre brede herwaardering": "01 Pre brede herwaardering",
    "02 Brede herwaardering": "02 Brede herwaardering",
    "03 IB 2001": "03 IB 2001",
});
export const FiscaleRegimeType = Object.freeze({
    "01 Voor 1-1-2013": "01 Voor 1-1-2013",
    "02 Vanaf 1-1-2013": "02 Vanaf 1-1-2013",
    "03 Fiscaal regime niet van toepassing": "03 Fiscaal regime niet van toepassing",
});
export const FiscaleVormType = Object.freeze({
    "01 SEW": "01 SEW",
    "02 BEW": "02 BEW",
    "03 KEW": "03 KEW",
    "04 Kapitaalverzekering zonder eigen woningclausule": "04 Kapitaalverzekering zonder eigen woningclausule",
});
export const GarantieType = Object.freeze({
    "01 NHG-garantie": "01 NHG-garantie",
    "02 gemeentegarantie": "02 gemeentegarantie",
    "03 geen garantie": "03 geen garantie",
});
export const GeregistreerdeLeningType = Object.freeze({
    "AK Aflopend krediet": "AK Aflopend krediet",
    "HO Hypothecair krediet overige onroerende zaken": "HO Hypothecair krediet overige onroerende zaken",
    "HY Hypothecair krediet eigen woning": "HY Hypothecair krediet eigen woning",
    "OA Operational Autolease": "OA Operational Autolease",
    "RH Restschuld zonder aanspraak op NHG": "RH Restschuld zonder aanspraak op NHG",
    "RK Doorlopend krediet": "RK Doorlopend krediet",
    "RN Restschuld met aanspraak op NHG": "RN Restschuld met aanspraak op NHG",
    "RO Overige financiële verplichtingen": "RO Overige financiële verplichtingen",
    "SH Schuldhulp": "SH Schuldhulp",
    "SK Saneringskrediet": "SK Saneringskrediet",
    "ZK Zakelijk krediet": "ZK Zakelijk krediet",
    "ZO Zakelijke overige financiële verplichtingen": "ZO Zakelijke overige financiële verplichtingen",
    "ZZ Anders": "ZZ Anders",
});
export const InkomenPeriodeType = Object.freeze({
    "01 per maand": "01 per maand",
    "04 per 4 weken": "04 per 4 weken",
    "12 per jaar": "12 per jaar",
    "52 per week": "52 per week",
});
export const InlegType = Object.freeze({
    "01 Periodieke inleg": "01 Periodieke inleg",
    "02 Eenmalige inleg": "02 Eenmalige inleg",
    "03 Periodieke onttrekking": "03 Periodieke onttrekking",
    "04 Eenmalige onttrekking": "04 Eenmalige onttrekking",
});
export const KlantSegmentMijType = Object.freeze({
    "IN005 Eigen personeel": "IN005 Eigen personeel",
});
export const LandType = Object.freeze({
    "AD Andorra": "AD Andorra",
    "AE Verenigde Arabische Emiraten": "AE Verenigde Arabische Emiraten",
    "AF Afghanistan": "AF Afghanistan",
    "AG Antigua en Barbuda": "AG Antigua en Barbuda",
    "AI Anguilla": "AI Anguilla",
    "AL Albanië": "AL Albanië",
    "AM Armenië": "AM Armenië",
    "AO Angola": "AO Angola",
    "AQ Antarctica": "AQ Antarctica",
    "AR Argentinië": "AR Argentinië",
    "AS Amerikaans-Samoa": "AS Amerikaans-Samoa",
    "AT Oostenrijk": "AT Oostenrijk",
    "AU Australië": "AU Australië",
    "AW Aruba": "AW Aruba",
    "AX Åland": "AX Åland",
    "AZ Azerbeidzjan": "AZ Azerbeidzjan",
    "BA Bosnië Herzegovina": "BA Bosnië Herzegovina",
    "BB Barbados": "BB Barbados",
    "BD Bangladesh": "BD Bangladesh",
    "BE België": "BE België",
    "BF Burkina Faso": "BF Burkina Faso",
    "BG Bulgarije": "BG Bulgarije",
    "BH Bahrein": "BH Bahrein",
    "BI Burundi": "BI Burundi",
    "BJ Benin": "BJ Benin",
    "BL Saint-Barthélemy": "BL Saint-Barthélemy",
    "BM Bermuda": "BM Bermuda",
    "BN Brunei": "BN Brunei",
    "BO Bolivia": "BO Bolivia",
    "BQ Bonaire, Sint Eustatius en Saba": "BQ Bonaire, Sint Eustatius en Saba",
    "BR Brazilië": "BR Brazilië",
    "BS Bahama's": "BS Bahama's",
    "BT Bhutan": "BT Bhutan",
    "BV Bouveteiland": "BV Bouveteiland",
    "BW Botswana": "BW Botswana",
    "BY Wit-Rusland": "BY Wit-Rusland",
    "BZ Belize": "BZ Belize",
    "CA Canada": "CA Canada",
    "CC Cocoseilanden": "CC Cocoseilanden",
    "CD Congo-Kinshasa": "CD Congo-Kinshasa",
    "CF Centraal-Afrikaanse Republiek": "CF Centraal-Afrikaanse Republiek",
    "CG Republiek Congo": "CG Republiek Congo",
    "CH Zwitserland": "CH Zwitserland",
    "CI Ivoorkust": "CI Ivoorkust",
    "CK Cookeilanden": "CK Cookeilanden",
    "CL Chili": "CL Chili",
    "CM Kameroen": "CM Kameroen",
    "CN China": "CN China",
    "CO Colombia": "CO Colombia",
    "CR Costa Rica": "CR Costa Rica",
    "CU Cuba": "CU Cuba",
    "CV Kaapverdië": "CV Kaapverdië",
    "CW Curaçao": "CW Curaçao",
    "CX Christmaseiland": "CX Christmaseiland",
    "CY Cyprus": "CY Cyprus",
    "CZ Tsjechië": "CZ Tsjechië",
    "DE Duitsland": "DE Duitsland",
    "DJ Djibouti": "DJ Djibouti",
    "DK Denemarken": "DK Denemarken",
    "DM Dominica": "DM Dominica",
    "DO Dominicaanse Republiek": "DO Dominicaanse Republiek",
    "DZ Algerije": "DZ Algerije",
    "EC Ecuador": "EC Ecuador",
    "EE Estland": "EE Estland",
    "EG Egypte": "EG Egypte",
    "EH Westelijke Sahara": "EH Westelijke Sahara",
    "ER Eritrea": "ER Eritrea",
    "ES Spanje": "ES Spanje",
    "ET Ethiopië": "ET Ethiopië",
    "FI Finland": "FI Finland",
    "FJ Fiji": "FJ Fiji",
    "FK Falklandeilanden": "FK Falklandeilanden",
    "FM Micronesia": "FM Micronesia",
    "FO Faeröer": "FO Faeröer",
    "FR Frankrijk": "FR Frankrijk",
    "GA Gabon": "GA Gabon",
    "GB Verenigd Koninkrijk": "GB Verenigd Koninkrijk",
    "GD Grenada": "GD Grenada",
    "GE Georgië": "GE Georgië",
    "GF Frans-Guyana": "GF Frans-Guyana",
    "GG Guernsey": "GG Guernsey",
    "GH Ghana": "GH Ghana",
    "GI Gibraltar": "GI Gibraltar",
    "GL Groenland": "GL Groenland",
    "GM Gambia": "GM Gambia",
    "GN Guinee": "GN Guinee",
    "GP Guadeloupe": "GP Guadeloupe",
    "GQ Equatoriaal-Guinea": "GQ Equatoriaal-Guinea",
    "GR Griekenland": "GR Griekenland",
    "GS Zuid-Georgia en de Zuidelijke Sandwicheilanden": "GS Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    "GT Guatemala": "GT Guatemala",
    "GU Guam": "GU Guam",
    "GW Guinee-Bissau": "GW Guinee-Bissau",
    "GY Guyana": "GY Guyana",
    "HK Hongkong": "HK Hongkong",
    "HM Heard en McDonaldeilanden": "HM Heard en McDonaldeilanden",
    "HN Honduras": "HN Honduras",
    "HR Kroatië": "HR Kroatië",
    "HT Haïti": "HT Haïti",
    "HU Hongarije": "HU Hongarije",
    "ID Indonesië": "ID Indonesië",
    "IE Ierland": "IE Ierland",
    "IL Israël": "IL Israël",
    "IM Man": "IM Man",
    "IN India": "IN India",
    "IO Brits Indische Oceaanterritorium": "IO Brits Indische Oceaanterritorium",
    "IQ Irak": "IQ Irak",
    "IR Iran": "IR Iran",
    "IS IJsland": "IS IJsland",
    "IT Italië": "IT Italië",
    "JE Jersey": "JE Jersey",
    "JM Jamaica": "JM Jamaica",
    "JO Jordanië": "JO Jordanië",
    "JP Japan": "JP Japan",
    "KE Kenia": "KE Kenia",
    "KG Kirgizië": "KG Kirgizië",
    "KH Cambodja": "KH Cambodja",
    "KI Kiribati": "KI Kiribati",
    "KM Comoren": "KM Comoren",
    "KN Saint Kitts en Nevis": "KN Saint Kitts en Nevis",
    "KP Noord-Korea": "KP Noord-Korea",
    "KR Zuid-Korea": "KR Zuid-Korea",
    "KW Koeweit": "KW Koeweit",
    "KY Kaaimaneilanden": "KY Kaaimaneilanden",
    "KZ Kazachstan": "KZ Kazachstan",
    "LA Laos": "LA Laos",
    "LB Libanon": "LB Libanon",
    "LC Saint Lucia": "LC Saint Lucia",
    "LI Liechtenstein": "LI Liechtenstein",
    "LK Sri Lanka": "LK Sri Lanka",
    "LR Liberia": "LR Liberia",
    "LS Lesotho": "LS Lesotho",
    "LT Litouwen": "LT Litouwen",
    "LU Luxemburg": "LU Luxemburg",
    "LV Letland": "LV Letland",
    "LY Libië": "LY Libië",
    "MA Marokko": "MA Marokko",
    "MC Monaco": "MC Monaco",
    "MD Moldavië": "MD Moldavië",
    "ME Montenegro": "ME Montenegro",
    "MF Sint-Maarten (FR)": "MF Sint-Maarten (FR)",
    "MG Madagaskar": "MG Madagaskar",
    "MH Marshalleilanden": "MH Marshalleilanden",
    "MK Noord Macedonië": "MK Noord Macedonië",
    "ML Mali": "ML Mali",
    "MM Myanmar": "MM Myanmar",
    "MN Mongolië": "MN Mongolië",
    "MO Macau": "MO Macau",
    "MP Noordelijke Marianen": "MP Noordelijke Marianen",
    "MQ Martinique": "MQ Martinique",
    "MR Mauritanië": "MR Mauritanië",
    "MS Montserrat": "MS Montserrat",
    "MT Malta": "MT Malta",
    "MU Mauritius": "MU Mauritius",
    "MV Maldiven": "MV Maldiven",
    "MW Malawi": "MW Malawi",
    "MX Mexico": "MX Mexico",
    "MY Maleisië": "MY Maleisië",
    "MZ Mozambique": "MZ Mozambique",
    "NA Namibië": "NA Namibië",
    "NC Nieuw-Caledonië": "NC Nieuw-Caledonië",
    "NE Niger": "NE Niger",
    "NF Norfolk": "NF Norfolk",
    "NG Nigeria": "NG Nigeria",
    "NI Nicaragua": "NI Nicaragua",
    "NL Nederland": "NL Nederland",
    "NO Noorwegen": "NO Noorwegen",
    "NP Nepal": "NP Nepal",
    "NR Nauru": "NR Nauru",
    "NU Niue": "NU Niue",
    "NZ Nieuw-Zeeland": "NZ Nieuw-Zeeland",
    "OM Oman": "OM Oman",
    "PA Panama": "PA Panama",
    "PE Peru": "PE Peru",
    "PF Frans-Polynesië": "PF Frans-Polynesië",
    "PG Papoea-Nieuw-Guinea": "PG Papoea-Nieuw-Guinea",
    "PH Filipijnen": "PH Filipijnen",
    "PK Pakistan": "PK Pakistan",
    "PL Polen": "PL Polen",
    "PM Saint-Pierre en Miquelon": "PM Saint-Pierre en Miquelon",
    "PN Pitcairneilanden": "PN Pitcairneilanden",
    "PR Puerto Rico": "PR Puerto Rico",
    "PS Palestina": "PS Palestina",
    "PT Portugal": "PT Portugal",
    "PW Palau": "PW Palau",
    "PY Paraguay": "PY Paraguay",
    "QA Qatar": "QA Qatar",
    "RE Réunion": "RE Réunion",
    "RO Roemenië": "RO Roemenië",
    "RS Servië": "RS Servië",
    "RU Rusland": "RU Rusland",
    "RW Rwanda": "RW Rwanda",
    "SA Saoedi-Arabië": "SA Saoedi-Arabië",
    "SB Salomonseilanden": "SB Salomonseilanden",
    "SC Seychellen": "SC Seychellen",
    "SD Soedan": "SD Soedan",
    "SE Zweden": "SE Zweden",
    "SG Singapore": "SG Singapore",
    "SH Sint-Helena, Ascension en Tristan da Cunha": "SH Sint-Helena, Ascension en Tristan da Cunha",
    "SI Slovenië": "SI Slovenië",
    "SJ Spitsbergen en Jan Mayen": "SJ Spitsbergen en Jan Mayen",
    "SK Slowakije": "SK Slowakije",
    "SL Sierra Leone": "SL Sierra Leone",
    "SM San Marino": "SM San Marino",
    "SN Senegal": "SN Senegal",
    "SO Somalië": "SO Somalië",
    "SR Suriname": "SR Suriname",
    "SS Zuid-Soedan": "SS Zuid-Soedan",
    "ST Sao Tomé en Principe": "ST Sao Tomé en Principe",
    "SV El Salvador": "SV El Salvador",
    "SX Sint-Maarten (NL)": "SX Sint-Maarten (NL)",
    "SY Syrië": "SY Syrië",
    "SZ Swaziland": "SZ Swaziland",
    "TC Turks- en Caicoseilanden": "TC Turks- en Caicoseilanden",
    "TD Tsjaad": "TD Tsjaad",
    "TF Franse Zuidelijke en Antarctische Gebieden": "TF Franse Zuidelijke en Antarctische Gebieden",
    "TG Togo": "TG Togo",
    "TH Thailand": "TH Thailand",
    "TJ Tadzjikistan": "TJ Tadzjikistan",
    "TK Tokelau": "TK Tokelau",
    "TL Oost-Timor": "TL Oost-Timor",
    "TM Turkmenistan": "TM Turkmenistan",
    "TN Tunesië": "TN Tunesië",
    "TO Tonga": "TO Tonga",
    "TR Turkije": "TR Turkije",
    "TT Trinidad en Tobago": "TT Trinidad en Tobago",
    "TV Tuvalu": "TV Tuvalu",
    "TW Taiwan": "TW Taiwan",
    "TZ Tanzania": "TZ Tanzania",
    "UA Oekraïne": "UA Oekraïne",
    "UG Oeganda": "UG Oeganda",
    "UM Kleine Pacifische eilanden van de Verenigde Staten": "UM Kleine Pacifische eilanden van de Verenigde Staten",
    "US Verenigde Staten": "US Verenigde Staten",
    "UY Uruguay": "UY Uruguay",
    "UZ Oezbekistan": "UZ Oezbekistan",
    "VA Vaticaanstad": "VA Vaticaanstad",
    "VC Saint Vincent en de Grenadines": "VC Saint Vincent en de Grenadines",
    "VE Venezuela": "VE Venezuela",
    "VG Britse Maagdeneilanden": "VG Britse Maagdeneilanden",
    "VI Amerikaanse Maagdeneilanden": "VI Amerikaanse Maagdeneilanden",
    "VN Vietnam": "VN Vietnam",
    "VU Vanuatu": "VU Vanuatu",
    "WF Wallis en Futuna": "WF Wallis en Futuna",
    "WS Samoa": "WS Samoa",
    "XK Kosovo": "XK Kosovo",
    "YE Jemen": "YE Jemen",
    "YT Mayotte": "YT Mayotte",
    "ZA Zuid-Afrika": "ZA Zuid-Afrika",
    "ZM Zambia": "ZM Zambia",
    "ZW Zimbabwe": "ZW Zimbabwe",
});
export const LegitimatieGeslachtType = Object.freeze({
    "01 M": "01 M",
    "02 V": "02 V",
    "03 X": "03 X",
});
export const LegitimatieSoortType = Object.freeze({
    "ED Elektronisch Identiteitsbewijs": "ED Elektronisch Identiteitsbewijs",
    "EI Europese identiteitskaart": "EI Europese identiteitskaart",
    "PP Paspoort": "PP Paspoort",
    "RB Rijbewijs": "RB Rijbewijs",
    "VI Visum": "VI Visum",
});
export const MaatschappijType = Object.freeze({
    "AA ABN AMRO Bank N.V.": "AA ABN AMRO Bank N.V.",
    "AB ABP Hypotheken": "AB ABP Hypotheken",
    "AC Amstelstaete": "AC Amstelstaete",
    "AD Avéro Achmea Bancaire Diensten": "AD Avéro Achmea Bancaire Diensten",
    "AE AEGON Verzekeringen": "AE AEGON Verzekeringen",
    "AF De Amersfoortse": "AF De Amersfoortse",
    "AG ABN AMRO Hypotheken Groep": "AG ABN AMRO Hypotheken Groep",
    "AH Algemene Verzekering mij": "AH Algemene Verzekering mij",
    "AI Atrios": "AI Atrios",
    "AJ Allianz Asset Management": "AJ Allianz Asset Management",
    "AK ASN Bank": "AK ASN Bank",
    "AL Alkmaar Hypotheken B.V.": "AL Alkmaar Hypotheken B.V.",
    "AM AMEV Levensverzekeringen N.V.": "AM AMEV Levensverzekeringen N.V.",
    "AN Albank": "AN Albank",
    "AO AON Warranty Group": "AO AON Warranty Group",
    "AP ACE Europe Life": "AP ACE Europe Life",
    "AQ Attens Hypotheken": "AQ Attens Hypotheken",
    "AR Argenta": "AR Argenta",
    "AS Amstelhuys": "AS Amstelhuys",
    "AT Stichting Beleggingsrekening ANT Trust": "AT Stichting Beleggingsrekening ANT Trust",
    "AU ASR": "AU ASR",
    "AV Avero Achmea": "AV Avero Achmea",
    "AW Abel Hypotheken": "AW Abel Hypotheken",
    "AX Axa Beleggingen": "AX Axa Beleggingen",
    "AY Algemene Levensherverzekering Maatschappij": "AY Algemene Levensherverzekering Maatschappij",
    "AZ Allianz": "AZ Allianz",
    "BA Easybank Hypotheek": "BA Easybank Hypotheek",
    "BB BijBouwe": "BB BijBouwe",
    "BC Basic Life": "BC Basic Life",
    "BD Brand New Day Vermogensbeheer N.V.": "BD Brand New Day Vermogensbeheer N.V.",
    "BF Bouwfonds Hypotheken bv": "BF Bouwfonds Hypotheken bv",
    "BI Effectenbank Binck": "BI Effectenbank Binck",
    "BL BLG Hypotheken": "BL BLG Hypotheken",
    "BN BNP Paribas Personal Finance": "BN BNP Paribas Personal Finance",
    "BO BOS": "BO BOS",
    "BP Van Berkel Capital Partners": "BP Van Berkel Capital Partners",
    "BQ bunq": "BQ bunq",
    "BS Bouwsteen Hypotheken": "BS Bouwsteen Hypotheken",
    "BU Combi BudgetPlus Hypotheken": "BU Combi BudgetPlus Hypotheken",
    "CA Cardif": "CA Cardif",
    "CB Centraal Beheer": "CB Centraal Beheer",
    "CC Credo Hypotheken": "CC Credo Hypotheken",
    "CD CDK-Bank": "CD CDK-Bank",
    "CE Credivance": "CE Credivance",
    "CF Credit Life": "CF Credit Life",
    "CH CombiVoordeel Hypotheken B.V.": "CH CombiVoordeel Hypotheken B.V.",
    "CI Credit Life International N.V": "CI Credit Life International N.V",
    "CL Colibri Hypotheken": "CL Colibri Hypotheken",
    "CO Combi Hypotheken B.V.": "CO Combi Hypotheken B.V.",
    "CP Capitalum": "CP Capitalum",
    "CR Cordares": "CR Cordares",
    "CV CVB Bank": "CV CVB Bank",
    "CW Clarian Wonen": "CW Clarian Wonen",
    "CX Conservatrix N.V.": "CX Conservatrix N.V.",
    "DA Dela Verzekeringen": "DA Dela Verzekeringen",
    "DB Direktbank": "DB Direktbank",
    "DC DFM": "DC DFM",
    "DD Dynamic Hypotheken": "DD Dynamic Hypotheken",
    "DE DSB Leven": "DE DSB Leven",
    "DF De Federale": "DF De Federale",
    "DH Domus Hypotheken": "DH Domus Hypotheken",
    "DL Delta Lloyd": "DL Delta Lloyd",
    "DM Defam": "DM Defam",
    "DN DNGB": "DN DNGB",
    "DO Dohmen & Otten Vermogensbeheer": "DO Dohmen & Otten Vermogensbeheer",
    "DS DSB Bank": "DS DSB Bank",
    "DV DBV": "DV DBV",
    "DW DWS Investments": "DW DWS Investments",
    "DY Dynamic": "DY Dynamic",
    "EB EBO": "EB EBO",
    "ED EDC Assuradeuren B.V.": "ED EDC Assuradeuren B.V.",
    "EF Efima Hypotheken B.V.": "EF Efima Hypotheken B.V.",
    "EG ERGO Life": "EG ERGO Life",
    "EH Eerste Hollandse Leven": "EH Eerste Hollandse Leven",
    "EL AXA Leven": "EL AXA Leven",
    "EP EuropeLife": "EP EuropeLife",
    "EQ ELQ Hypotheken": "EQ ELQ Hypotheken",
    "ER Erasmusleven N.V.": "ER Erasmusleven N.V.",
    "ES Estate": "ES Estate",
    "EU Eureffect": "EU Eureffect",
    "EV Elvia Verzekeringen": "EV Elvia Verzekeringen",
    "FA Financieel Bureau Academici": "FA Financieel Bureau Academici",
    "FB Friesland Bank": "FB Friesland Bank",
    "FD Fidelity Investments": "FD Fidelity Investments",
    "FE Friesland Bank Securities": "FE Friesland Bank Securities",
    "FG FlexGarant": "FG FlexGarant",
    "FH Florius": "FH Florius",
    "FI Finata Bank": "FI Finata Bank",
    "FL Falcon Leven N.V.": "FL Falcon Leven N.V.",
    "FN FNV Leden Verzekeringen": "FN FNV Leden Verzekeringen",
    "FO Fortis ASR Verzekeringsgroep N.V.": "FO Fortis ASR Verzekeringsgroep N.V.",
    "FR Fairgo": "FR Fairgo",
    "FS Finsys": "FS Finsys",
    "FT FBTO": "FT FBTO",
    "FU Fundselector": "FU Fundselector",
    "FV Final Trust Vermogensbeheer": "FV Final Trust Vermogensbeheer",
    "FZ Forza Asset Management": "FZ Forza Asset Management",
    "GB Garantiebeheer": "GB Garantiebeheer",
    "GE Gema": "GE Gema",
    "GH Groene Hart Hypotheken": "GH Groene Hart Hypotheken",
    "GM GMAC": "GM GMAC",
    "GO Goudse Verzekeringen B.V.": "GO Goudse Verzekeringen B.V.",
    "GV Generali Verzekeringen": "GV Generali Verzekeringen",
    "HA Hansard Europe Ltd": "HA Hansard Europe Ltd",
    "HB Holland Beleggings Groep": "HB Holland Beleggings Groep",
    "HD Hollandsche Bank Unie": "HD Hollandsche Bank Unie",
    "HE Helvetia Verzekeringen": "HE Helvetia Verzekeringen",
    "HH Hooge Huys Verzekeringen": "HH Hooge Huys Verzekeringen",
    "HL Holland Woningfinanciering N.V.": "HL Holland Woningfinanciering N.V.",
    "HM Hamburg-Mannheimer": "HM Hamburg-Mannheimer",
    "HN HNG Hypotheken": "HN HNG Hypotheken",
    "HO Houtvaart Hypotheken B.V.": "HO Houtvaart Hypotheken B.V.",
    "HQ HQ Hypotheken": "HQ HQ Hypotheken",
    "HT Hypotrust": "HT Hypotrust",
    "HU Huizen": "HU Huizen",
    "HV HollandWoont": "HV HollandWoont",
    "HW Hooge Huys Woningfonds": "HW Hooge Huys Woningfonds",
    "HY Hypinvest": "HY Hypinvest",
    "IA Insinger Assetmanagement": "IA Insinger Assetmanagement",
    "IB Insinger de Beaufort N.V., Bank": "IB Insinger de Beaufort N.V., Bank",
    "ID idm bank": "ID idm bank",
    "II IPTIQ": "II IPTIQ",
    "IK IKS": "IK IKS",
    "IL Interlloyd Levensverzekering Maatschappij N.V.": "IL Interlloyd Levensverzekering Maatschappij N.V.",
    "IM Impact Hypotheken": "IM Impact Hypotheken",
    "IN ING Bank": "IN ING Bank",
    "IO Innofin": "IO Innofin",
    "IP Interpolis": "IP Interpolis",
    "IQ IQWOON": "IQ IQWOON",
    "IT Interbank": "IT Interbank",
    "IV International Value Management": "IV International Value Management",
    "JU Jungo": "JU Jungo",
    "KB Knab": "KB Knab",
    "KC Keijser Capital": "KC Keijser Capital",
    "KH KBC": "KH KBC",
    "KL Klaverblad Verzekeringen N.V.": "KL Klaverblad Verzekeringen N.V.",
    "KN Koninklijke Nedloyd": "KN Koninklijke Nedloyd",
    "LA ASR Leven": "LA ASR Leven",
    "LB F. van Lanschot Bankiers": "LB F. van Lanschot Bankiers",
    "LE Levob Verzekeringen": "LE Levob Verzekeringen",
    "LG Legal & General": "LG Legal & General",
    "LH LOGON Hypotheken": "LH LOGON Hypotheken",
    "LK Van Lanschot Kempen": "LK Van Lanschot Kempen",
    "LL Lloyds Bank": "LL Lloyds Bank",
    "LO London Verzekeringen": "LO London Verzekeringen",
    "LT Lot Hypotheken": "LT Lot Hypotheken",
    "LV Leidscheverzekeringen": "LV Leidscheverzekeringen",
    "LY Loyalis": "LY Loyalis",
    "MA Matrix Asset Management": "MA Matrix Asset Management",
    "ME Merius": "ME Merius",
    "MG MGM International Assurance": "MG MGM International Assurance",
    "MH Bank Mees & Hope": "MH Bank Mees & Hope",
    "MM Mass Mutual Europe SA": "MM Mass Mutual Europe SA",
    "MN MNF Bank Hypotheken": "MN MNF Bank Hypotheken",
    "MO Monuta Levensverzekeringen N.V.": "MO Monuta Levensverzekeringen N.V.",
    "MP Mees Pierson": "MP Mees Pierson",
    "MS Morgan Stanley Investment Management": "MS Morgan Stanley Investment Management",
    "MT Munt Hypotheken": "MT Munt Hypotheken",
    "MU Muzen": "MU Muzen",
    "MY MoneYou": "MY MoneYou",
    "NA Nationale Notaris": "NA Nationale Notaris",
    "NE Noord Nederlands Effecten Kantoor": "NE Noord Nederlands Effecten Kantoor",
    "NF Stichting NOG Hypotheekfonds": "NF Stichting NOG Hypotheekfonds",
    "NH Nieuwe Hollandsche Lloyd": "NH Nieuwe Hollandsche Lloyd",
    "NI NIBC Direct Hypotheken B.V.": "NI NIBC Direct Hypotheken B.V.",
    "NK Nationale Nederlanden Kredieten": "NK Nationale Nederlanden Kredieten",
    "NL Nuts Levensverzekeringen van 1848 N.V.": "NL Nuts Levensverzekeringen van 1848 N.V.",
    "NN Nationale Nederlanden Hypotheken": "NN Nationale Nederlanden Hypotheken",
    "NO NOG Verzekeringen": "NO NOG Verzekeringen",
    "NP Nationale HypotheekPas": "NP Nationale HypotheekPas",
    "NR Nieuw Rotterdam Verzekeringen B.V.": "NR Nieuw Rotterdam Verzekeringen B.V.",
    "NT Nationale Hypotheek Maatschappij": "NT Nationale Hypotheek Maatschappij",
    "NU Nieuwegein": "NU Nieuwegein",
    "NV Nationale Nederlanden Verzekeringen": "NV Nationale Nederlanden Verzekeringen",
    "NW Nationale Waarborg": "NW Nationale Waarborg",
    "NX N26 Hypotheken": "NX N26 Hypotheken",
    "NY Nederlandse Hypotheekbank N.V.": "NY Nederlandse Hypotheekbank N.V.",
    "NZ NWWI": "NZ NWWI",
    "OG Onderlinge 's Gravenhage U.A.": "OG Onderlinge 's Gravenhage U.A.",
    "OH OHRA Verzekeringen": "OH OHRA Verzekeringen",
    "OO Oosteroever Hypotheken B.V.": "OO Oosteroever Hypotheken B.V.",
    "OP Optimix": "OP Optimix",
    "OR Orange Credit Hypotheken B.V.": "OR Orange Credit Hypotheken B.V.",
    "OS Ostrica B.V.": "OS Ostrica B.V.",
    "OV Obvion": "OV Obvion",
    "PA PBA Hypotheken": "PA PBA Hypotheken",
    "PB Postbank N.V.": "PB Postbank N.V.",
    "PD Palladyne Asset Management": "PD Palladyne Asset Management",
    "PL Paerel Leven": "PL Paerel Leven",
    "PM PPGM Levensverzekeringen N.V.": "PM PPGM Levensverzekeringen N.V.",
    "PP Philips Pensioenfonds": "PP Philips Pensioenfonds",
    "PQ Proteq": "PQ Proteq",
    "PR Prudential Leven N.V.": "PR Prudential Leven N.V.",
    "PV PVF Hypotheken": "PV PVF Hypotheken",
    "QL Quantum Leven": "QL Quantum Leven",
    "QT Qent Hypotheken": "QT Qent Hypotheken",
    "QU Quion": "QU Quion",
    "RB Rabo-hypotheekbank N.V.": "RB Rabo-hypotheekbank N.V.",
    "RC Robeco": "RC Robeco",
    "RD Reaal Bancaire Diensten": "RD Reaal Bancaire Diensten",
    "RE Reaal Hypotheken B.V.": "RE Reaal Hypotheken B.V.",
    "RF Robuust Hypotheken": "RF Robuust Hypotheken",
    "RG RegioBank": "RG RegioBank",
    "RH Rijnlandse Hypotheekbank": "RH Rijnlandse Hypotheekbank",
    "RI Robein": "RI Robein",
    "RL Royal Levensverzekerings Mij. N.V.": "RL Royal Levensverzekerings Mij. N.V.",
    "RO Roparco N.V.": "RO Roparco N.V.",
    "RR Royal Residentie": "RR Royal Residentie",
    "RV RVS Leven": "RV RVS Leven",
    "RW REAAL Woningfonds": "RW REAAL Woningfonds",
    "SA Royal & SunAlliance": "SA Royal & SunAlliance",
    "SB Stichting Bedrijfspensioenfonds Zorgverzekeraars": "SB Stichting Bedrijfspensioenfonds Zorgverzekeraars",
    "SC Schretlen": "SC Schretlen",
    "SD Scildon": "SD Scildon",
    "SE Seyst": "SE Seyst",
    "SF Selectief Hypotheken": "SF Selectief Hypotheken",
    "SH Sparck Hypotheken": "SH Sparck Hypotheken",
    "SI Simon A. Cohen": "SI Simon A. Cohen",
    "SL Spaarbank Limburg": "SL Spaarbank Limburg",
    "SM Someday": "SM Someday",
    "SN SNS Bank": "SN SNS Bank",
    "SP Spoorwegpensioenfonds": "SP Spoorwegpensioenfonds",
    "SQ Squarelife AG": "SQ Squarelife AG",
    "SR Stad Rotterdam N.V.": "SR Stad Rotterdam N.V.",
    "ST Stad en Land": "ST Stad en Land",
    "SY Syntrus Achmea Hypotheken": "SY Syntrus Achmea Hypotheken",
    "TA Triple Assets Investment Services": "TA Triple Assets Investment Services",
    "TB Triodos Bank N.V.": "TB Triodos Bank N.V.",
    "TC Bank Ten Cate & Cie": "TC Bank Ten Cate & Cie",
    "TD Today's Beheer": "TD Today's Beheer",
    "TH Tulp Hypotheken": "TH Tulp Hypotheken",
    "TL Tellius Hypotheken": "TL Tellius Hypotheken",
    "TO Todays Tomorrow B.V.": "TO Todays Tomorrow B.V.",
    "TP TradingPort Vermogensbeheer": "TP TradingPort Vermogensbeheer",
    "TT Taxatheek": "TT Taxatheek",
    "TU Tiel Utrecht": "TU Tiel Utrecht",
    "UA N.V. Levensverzekerings Mij UAP-Nederland": "UA N.V. Levensverzekerings Mij UAP-Nederland",
    "UB UBO": "UB UBO",
    "UC UCB": "UC UCB",
    "UL Universal Leven": "UL Universal Leven",
    "UN Unigarant Verzekeringen": "UN Unigarant Verzekeringen",
    "UV Univé Verzekeringen": "UV Univé Verzekeringen",
    "VA Vista Hypotheken": "VA Vista Hypotheken",
    "VB Volksbank": "VB Volksbank",
    "VC Victorie Hypotheken": "VC Victorie Hypotheken",
    "VE Venn Hypotheken": "VE Venn Hypotheken",
    "VF Vandaag Hypotheken": "VF Vandaag Hypotheken",
    "VH Vezeno Hypotheken N.V.": "VH Vezeno Hypotheken N.V.",
    "VI Vierlander Effecten": "VI Vierlander Effecten",
    "VN Van Nierop": "VN Van Nierop",
    "VO VORSORGE Luxemburg Lebensversicherung": "VO VORSORGE Luxemburg Lebensversicherung",
    "VR Verder Hypotheken": "VR Verder Hypotheken",
    "VS VSB-Bank N.V.": "VS VSB-Bank N.V.",
    "VV VVAA Levensverzekeringen N.V.": "VV VVAA Levensverzekeringen N.V.",
    "WF Woonfonds Hypotheken": "WF Woonfonds Hypotheken",
    "WH Wilgenhaege Vermogensbeheer": "WH Wilgenhaege Vermogensbeheer",
    "WI Winterthur Verzekeringen": "WI Winterthur Verzekeringen",
    "WL Waard Leven N.V.": "WL Waard Leven N.V.",
    "WN Woonnexxt": "WN Woonnexxt",
    "WO Woudsend Verzekeringen N.V.": "WO Woudsend Verzekeringen N.V.",
    "WU Westland/Utrecht Hypotheken": "WU Westland/Utrecht Hypotheken",
    "WV Woonvoordeel": "WV Woonvoordeel",
    "WX Woonnu": "WX Woonnu",
    "XX maatschappij onbekend": "XX maatschappij onbekend",
    "ZA Zwolsche Algemeene": "ZA Zwolsche Algemeene",
    "ZL Zwitserleven": "ZL Zwitserleven",
    "ZU Zurich Leven": "ZU Zurich Leven",
    "ZW Zwaluw": "ZW Zwaluw",
    "ZZ Anders": "ZZ Anders",
});
export const MaatwerkOplCodeMijType = Object.freeze({
    "AA009 Meefinancieren restschuld huidige woning": "AA009 Meefinancieren restschuld huidige woning",
    "AA011 Lage hypotheek op inkomen": "AA011 Lage hypotheek op inkomen",
    "AA013 Doorstromer": "AA013 Doorstromer",
    "AE009 Werkelijke woonlasten": "AE009 Werkelijke woonlasten",
    "AK001 Overig": "AK001 Overig",
    "BL001 Overig": "BL001 Overig",
    "FH009 Meefinancieren restschuld huidige woning": "FH009 Meefinancieren restschuld huidige woning",
    "FH011 Lage hypotheek op inkomen": "FH011 Lage hypotheek op inkomen",
    "FH013 Doorstromer": "FH013 Doorstromer",
    "IM002 Baanwissel": "IM002 Baanwissel",
    "IN002 Ontslag hoofdelijk aansprakelijkheid": "IN002 Ontslag hoofdelijk aansprakelijkheid",
    "IN003 Uitzondering toetsing oversluiten": "IN003 Uitzondering toetsing oversluiten",
    "IN004 Uitzondering toetsing restschuldfinanciering": "IN004 Uitzondering toetsing restschuldfinanciering",
    "IN005 Uitzondering toetsing pensioeninkomen": "IN005 Uitzondering toetsing pensioeninkomen",
    "IN006 Uitzondering toetsing naderend pensioeninkomen": "IN006 Uitzondering toetsing naderend pensioeninkomen",
    "IN007 Tijdelijke inkomensarme periode": "IN007 Tijdelijke inkomensarme periode",
    "IN008 Combinatie tijdelijke inkomensarme periode en uitzondering toetsing naderend pensioeninkomen": "IN008 Combinatie tijdelijke inkomensarme periode en uitzondering toetsing naderend pensioeninkomen",
    "IN009 Expat": "IN009 Expat",
    "ME002 Baanwissel": "ME002 Baanwissel",
    "MT001 Scheidingspropositie": "MT001 Scheidingspropositie",
    "MT002 Inkomen uit verhuur (particulier)": "MT002 Inkomen uit verhuur (particulier)",
    "MT003 Inkomen uit verhuur (semi-professioneel)": "MT003 Inkomen uit verhuur (semi-professioneel)",
    "NN001 Substantieel lagere lasten": "NN001 Substantieel lagere lasten",
    "NN010 Energiebesparende Voorzieningen": "NN010 Energiebesparende Voorzieningen",
    "NN012 Oversluiten LTV": "NN012 Oversluiten LTV",
    "NN013 Oversluiten LTI": "NN013 Oversluiten LTI",
    "NN014 Goedkoper Wonen": "NN014 Goedkoper Wonen",
    "RB015 Relatiebeëindiging/Uit elkaar gaan (hogere LTI)": "RB015 Relatiebeëindiging/Uit elkaar gaan (hogere LTI)",
    "RB016 Achterstallige betalingen vereniging van eigenaars (hogere LTV)": "RB016 Achterstallige betalingen vereniging van eigenaars (hogere LTV)",
    "RB017 Noodzakelijke woningverbetering (hogere LTV)": "RB017 Noodzakelijke woningverbetering (hogere LTV)",
    "RB018 Inkomensdaling binnen 10 jaar (hogere LTI)": "RB018 Inkomensdaling binnen 10 jaar (hogere LTI)",
    "RB021 Goedkoper wonen voor senioren": "RB021 Goedkoper wonen voor senioren",
    "RB022 Aanvullende lening woningverbetering senioren": "RB022 Aanvullende lening woningverbetering senioren",
    "RB023 Interne oversluiting rentecontract met verhoging van financieringskosten": "RB023 Interne oversluiting rentecontract met verhoging van financieringskosten",
    "RB024 Herfinancieren overbrugging en/of restschuld": "RB024 Herfinancieren overbrugging en/of restschuld",
    "RB025 Herfinancieren aflossingsvrij op einddatum": "RB025 Herfinancieren aflossingsvrij op einddatum",
    "RB026 Explain Afwijken Documentenlijst": "RB026 Explain Afwijken Documentenlijst",
    "RB027 Explain Afwijken Klant": "RB027 Explain Afwijken Klant",
    "RB028 Explain Afwijken Zekerheden": "RB028 Explain Afwijken Zekerheden",
    "RB029 Explain Afwijken Inkomen": "RB029 Explain Afwijken Inkomen",
    "RB030 Explain Onttrekken Box 3 Vermogen": "RB030 Explain Onttrekken Box 3 Vermogen",
    "RB031 Tijdelijk tekort senioren": "RB031 Tijdelijk tekort senioren",
    "RG001 Overig": "RG001 Overig",
    "SN001 Overig": "SN001 Overig",
    "WF006 Medehoofdelijk schuldenaarschap": "WF006 Medehoofdelijk schuldenaarschap",
    "WF007 Lasten  60% maximale leencapaciteit": "WF007 Lasten  60% maximale leencapaciteit",
    "WF010 Restschuld bij verkoop vorige woning": "WF010 Restschuld bij verkoop vorige woning",
});
export const MutatieType = Object.freeze({
    "01 Aankoop woning": "01 Aankoop woning",
    "04 Verwerving uit onverdeelde boedel": "04 Verwerving uit onverdeelde boedel",
    "07 Afkoop erfpacht": "07 Afkoop erfpacht",
    "27 Echtscheiding": "27 Echtscheiding",
    "28 Kwaliteitsverbetering": "28 Kwaliteitsverbetering",
    "29 Verwerving volle eigendom": "29 Verwerving volle eigendom",
    "30 Aankoop via regioveiling": "30 Aankoop via regioveiling",
    "31 Verbeterde klantsituatie": "31 Verbeterde klantsituatie",
    "32 Oversluiten zonder verhoging": "32 Oversluiten zonder verhoging",
    "33 Overname SVn Starterslening": "33 Overname SVn Starterslening",
    "34 Meerdere financieringsdoelen": "34 Meerdere financieringsdoelen",
    "35 Financieren wijzigingskosten": "35 Financieren wijzigingskosten",
    "37 Volledige afbetaling van het ondersteuningsdeel": "37 Volledige afbetaling van het ondersteuningsdeel",
});
export const NotarisType = Object.freeze({
    "1 Passerend": "1 Passerend",
    "2 Transporterend": "2 Transporterend",
    "3 Opsteller garantieverklaring": "3 Opsteller garantieverklaring",
});
export const ObjectSoortType = Object.freeze({
    "01 Vrijstaande woning": "01 Vrijstaande woning",
    "02 2-onder-1-kapwoning": "02 2-onder-1-kapwoning",
    "03 Geschakelde 2-onder-1-kapwoning": "03 Geschakelde 2-onder-1-kapwoning",
    "04 Geschakelde woning": "04 Geschakelde woning",
    "05 Halfvrijstaande woning": "05 Halfvrijstaande woning",
    "06 Tussenwoning": "06 Tussenwoning",
    "07 Hoekwoning": "07 Hoekwoning",
    "08 Eindwoning": "08 Eindwoning",
    "09 Galerijflat": "09 Galerijflat",
    "10 Portiekflat": "10 Portiekflat",
    "11 Corridorflat": "11 Corridorflat",
    "12 Maisonnette": "12 Maisonnette",
    "13 Benedenwoning": "13 Benedenwoning",
    "14 Bovenwoning": "14 Bovenwoning",
    "15 Portiekwoning": "15 Portiekwoning",
    "16 Woonwagen / stacaravan": "16 Woonwagen / stacaravan",
    "17 Woonwagenstandplaats / stacaravanstandplaats": "17 Woonwagenstandplaats / stacaravanstandplaats",
    "18 Woonboot": "18 Woonboot",
    "19 Ligplaats": "19 Ligplaats",
    "20 Waterwoning": "20 Waterwoning",
    "21 Woon-/winkelpand": "21 Woon-/winkelpand",
    "22 Bouwkavel": "22 Bouwkavel",
    "23 Garage": "23 Garage",
    "24 Parkeerplaats (dienstbaar aan wonen)": "24 Parkeerplaats (dienstbaar aan wonen)",
    "25 Berging": "25 Berging",
});
export const OnderhoudsToestandType = Object.freeze({
    "01 Goed": "01 Goed",
    "02 Voldoende": "02 Voldoende",
    "03 Matig": "03 Matig",
    "04 Slecht": "04 Slecht",
    "05 Aanschrijving gemeente": "05 Aanschrijving gemeente",
    "06 Onbekend": "06 Onbekend",
});
export const OorspronkelijkBindendAanbodType = Object.freeze({
    "01 Voor 1-1-2023": "01 Voor 1-1-2023",
    "02 Vanaf 1-1-2023": "02 Vanaf 1-1-2023",
});
export const OpleidingsNiveauType = Object.freeze({
    "01 Lager onderwijs": "01 Lager onderwijs",
    "02 Voortgezet onderwijs (MAVO/HAVO)": "02 Voortgezet onderwijs (MAVO/HAVO)",
    "03 VWO": "03 VWO",
    "04 Lager beroepsonderwijs": "04 Lager beroepsonderwijs",
    "05 Middelbaar beroepsonderwijs": "05 Middelbaar beroepsonderwijs",
    "06 Hoger beroepsonderwijs": "06 Hoger beroepsonderwijs",
    "07 (post)Academisch": "07 (post)Academisch",
    "08 Onbekend": "08 Onbekend",
});
export const PremieType = Object.freeze({
    "01 Risicopremie normaal": "01 Risicopremie normaal",
    "03 Premie totaal normaal": "03 Premie totaal normaal",
    "05 Storting": "05 Storting",
});
export const RechtsVormType = Object.freeze({
    "BV Besloten vennootschap": "BV Besloten vennootschap",
    "CV Commanditaire vennootschap": "CV Commanditaire vennootschap",
    "EMZ Eenmanszaak": "EMZ Eenmanszaak",
    "MA Maatschap": "MA Maatschap",
    "NV Naamloze vennootschap": "NV Naamloze vennootschap",
    "ST Stichting": "ST Stichting",
    "VOF Vennootschap onder firma": "VOF Vennootschap onder firma",
});
export const RegelingType = Object.freeze({
    "01 eerste hypotheek (nieuw)": "01 eerste hypotheek (nieuw)",
    "04 onderhands": "04 onderhands",
    "05 omzetting": "05 omzetting",
    "07 interne oversluiting": "07 interne oversluiting",
    "08 oversluiting andere geldgever": "08 oversluiting andere geldgever",
    "09 tweede of hoger in rang hypotheek": "09 tweede of hoger in rang hypotheek",
    "10 meeneemhypotheek": "10 meeneemhypotheek",
    "11 doorgeefhypotheek": "11 doorgeefhypotheek",
});
export const RekenexpertType = Object.freeze({
    "01 Raadhuys Tax Legal Accounting": "01 Raadhuys Tax Legal Accounting",
    "02 Pentrax Advies": "02 Pentrax Advies",
    "03 Overviewz": "03 Overviewz",
    "04 Zakelijk Inkomen": "04 Zakelijk Inkomen",
    "05 Interne adviseur": "05 Interne adviseur",
    "06 Viiz": "06 Viiz",
});
export const RenteAfspraakType = Object.freeze({
    "01 rentevast": "01 rentevast",
    "02 rentedempend systeem": "02 rentedempend systeem",
    "03 continu variabel": "03 continu variabel",
});
export const RenteBedenktijdType = Object.freeze({
    "01 geen": "01 geen",
    "02 vooraf": "02 vooraf",
    "03 achteraf": "03 achteraf",
});
export const ServicerType = Object.freeze({
    "04 TAF": "04 TAF",
    "05 Callas": "05 Callas",
    "06 Hera Life": "06 Hera Life",
});
export const SoortBezittingBoxDrieType = Object.freeze({
    "01 banktegoeden": "01 banktegoeden",
    "02 girotegoeden": "02 girotegoeden",
    "03 spaartegoeden": "03 spaartegoeden",
    "04 aandelen": "04 aandelen",
    "05 obligaties": "05 obligaties",
    "06 contant geld": "06 contant geld",
    "07 onroerend goed": "07 onroerend goed",
    "99 overige bezittingen": "99 overige bezittingen",
});
export const SoortBouwType = Object.freeze({
    "01 Bestaande bouw": "01 Bestaande bouw",
    "02 Nieuwbouw": "02 Nieuwbouw",
});
export const SoortDienstBetrekkingType = Object.freeze({
    "08 flexibele arbeidsrelatie met perspectiefverklaring": "08 flexibele arbeidsrelatie met perspectiefverklaring",
    "09 flexibele arbeidsrelatie zonder perspectiefverklaring": "09 flexibele arbeidsrelatie zonder perspectiefverklaring",
    "10 loondienst vast": "10 loondienst vast",
    "11 loondienst tijdelijk met intentie": "11 loondienst tijdelijk met intentie",
    "12 loondienst tijdelijk zonder intentie": "12 loondienst tijdelijk zonder intentie",
});
export const SoortMeerwerkType = Object.freeze({
    "01 Regulier": "01 Regulier",
    "02 Verduurzaming": "02 Verduurzaming",
    "03 Regulier en verduurzaming": "03 Regulier en verduurzaming",
});
export const SoortNieuwbouwType = Object.freeze({
    "01 CPO": "01 CPO",
    "02 Zelfbouw": "02 Zelfbouw",
    "03 Projectbouw": "03 Projectbouw",
});
export const SoortOndernemingType = Object.freeze({
    "01 Zelfstandige Zonder Personeel (ZZP)": "01 Zelfstandige Zonder Personeel (ZZP)",
    "03 Zelfstandige met personeel": "03 Zelfstandige met personeel",
});
export const SoortOntbondenType = Object.freeze({
    "01 Huwelijk": "01 Huwelijk",
    "02 Geregistreerd partnerschap": "02 Geregistreerd partnerschap",
    "03 Beide": "03 Beide",
});
export const SoortOverigeInkomstenType = Object.freeze({
    "02 Schenking": "02 Schenking",
    "03 BoxTwee": "03 BoxTwee",
    "06 Partneralimentatie": "06 Partneralimentatie",
    "07 Kinderalimentatie": "07 Kinderalimentatie",
    "08 Inkomsten uit verhuur": "08 Inkomsten uit verhuur",
    "09 Resultaat uit overige werkzaamheden": "09 Resultaat uit overige werkzaamheden",
    "99 Anders": "99 Anders",
});
export const SoortOverigeLeningType = Object.freeze({
    "01 Lening bij werkgever": "01 Lening bij werkgever",
    "04 Lening bij derden": "04 Lening bij derden",
    "05 Basisbeurs": "05 Basisbeurs",
    "06 Leenstelsel": "06 Leenstelsel",
    "99 Anders": "99 Anders",
});
export const SoortPartijType = Object.freeze({
    "01 natuurlijk persoon": "01 natuurlijk persoon",
    "02 rechtspersoon": "02 rechtspersoon",
});
export const SoortToetsinkomenIBPType = Object.freeze({
    "01 Toetsinkomen voor AOW-leeftijd": "01 Toetsinkomen voor AOW-leeftijd",
    "02 Toetsinkomen bij AOW-leeftijd": "02 Toetsinkomen bij AOW-leeftijd",
});
export const SoortUitkeringType = Object.freeze({
    "02 Bijstand": "02 Bijstand",
    "03 WW": "03 WW",
    "04 Wachtgeld": "04 Wachtgeld",
    "05 RWW": "05 RWW",
    "06 ANW": "06 ANW",
    "07 Verzekering": "07 Verzekering",
    "08 Wajong": "08 Wajong",
    "09 AOW": "09 AOW",
    "10 WAZ": "10 WAZ",
    "11 WGA": "11 WGA",
    "12 IVA": "12 IVA",
    "13 WAO met herkeuring": "13 WAO met herkeuring",
    "14 WAO zonder herkeuring": "14 WAO zonder herkeuring",
    "15 Ouderdomspensioen": "15 Ouderdomspensioen",
    "16 Nabestaandenpensioen": "16 Nabestaandenpensioen",
});
export const SoortUitzendcontractType = Object.freeze({
    "01 Fase A": "01 Fase A",
    "02 Fase B": "02 Fase B",
    "03 Fase C": "03 Fase C",
    "04 n.v.t.": "04 n.v.t.",
});
export const SoortVerbouwingType = Object.freeze({
    "01 Regulier": "01 Regulier",
    "02 Verduurzaming": "02 Verduurzaming",
    "03 Regulier en verduurzaming": "03 Regulier en verduurzaming",
});
export const SoortVerduurzamingType = Object.freeze({
    "01 EBV": "01 EBV",
    "02 EBB": "02 EBB",
    "03 EBV en EBB": "03 EBV en EBB",
});
export const SoortVerzekerdKapType = Object.freeze({
    "01 Verzekerd bedrag bij overlijden": "01 Verzekerd bedrag bij overlijden",
    "02 Bedrag bij leven/expiratie/prognosekapitaal": "02 Bedrag bij leven/expiratie/prognosekapitaal",
    "03 Verzekerd percentage bij overlijden": "03 Verzekerd percentage bij overlijden",
    "04 Som van de premies": "04 Som van de premies",
    "05 Contractwaarde": "05 Contractwaarde",
});
export const SoortVerzekeringType = Object.freeze({
    "01 Lijfrente verzekering": "01 Lijfrente verzekering",
    "02 AO verzekering": "02 AO verzekering",
    "03 Woonlasten verzekering": "03 Woonlasten verzekering",
});
export const SoortWaardeType = Object.freeze({
    "01 Waarde op einddatum": "01 Waarde op einddatum",
    "02 Waarde bij aanvang": "02 Waarde bij aanvang",
    "03 Contractwaarde op peildatum": "03 Contractwaarde op peildatum",
});
export const SoortZelfbouwType = Object.freeze({
    "01 Zelfbouw met één aannemer": "01 Zelfbouw met één aannemer",
    "02 Zelfbouw met meerdere aannemers": "02 Zelfbouw met meerdere aannemers",
    "03 Zelfbouw zonder aannemer": "03 Zelfbouw zonder aannemer",
});
export const StudieleningInventarisatieType = Object.freeze({
    "01 Nee, want niet van toepassing": "01 Nee, want niet van toepassing",
    "02 Ja, maar geen sprake van een studielening": "02 Ja, maar geen sprake van een studielening",
    "03 Ja, er is sprake van een studielening": "03 Ja, er is sprake van een studielening",
});
export const SubsidieRegelingType = Object.freeze({
    "03 SVn Starterslening": "03 SVn Starterslening",
});
export const VerblijfsVergunningType = Object.freeze({
    "01 onbekend": "01 onbekend",
    "02 verblijfsvergunning onbepaalde tijd": "02 verblijfsvergunning onbepaalde tijd",
    "03 verblijfsvergunning bepaalde tijd": "03 verblijfsvergunning bepaalde tijd",
    "04 verblijfsvergunning voor bepaalde tijd asiel (Document III)": "04 verblijfsvergunning voor bepaalde tijd asiel (Document III)",
    "05 verblijfsvergunning voor onbepaalde tijd asiel (Document IV)": "05 verblijfsvergunning voor onbepaalde tijd asiel (Document IV)",
    "06 Verblijfsvergunning voor bepaalde tijd voor niet-tijdelijk verblijfsdoel": "06 Verblijfsvergunning voor bepaalde tijd voor niet-tijdelijk verblijfsdoel",
});
export const VerhuurType = Object.freeze({
    "01 geen verhuur": "01 geen verhuur",
    "02 tijdelijke verhuur": "02 tijdelijke verhuur",
    "03 gedeeltelijke tijdelijke verhuur (kamer, etage)": "03 gedeeltelijke tijdelijke verhuur (kamer, etage)",
    "04 gedeeltelijke verhuur (kamer, etage)": "04 gedeeltelijke verhuur (kamer, etage)",
    "05 permanente verhuur": "05 permanente verhuur",
});
export const VerkoopOnderVoorwaardenConstructieType = Object.freeze({
    "02 Maatschappelijk Verantwoord Eigendom (MVE)": "02 Maatschappelijk Verantwoord Eigendom (MVE)",
    "03 Koopgarant": "03 Koopgarant",
    "05 Koop Goedkoop": "05 Koop Goedkoop",
    "06 Slimmer Kopen (voorheen: Profijtwoning)": "06 Slimmer Kopen (voorheen: Profijtwoning)",
    "09 KmK-woning (Kopen met Korting)": "09 KmK-woning (Kopen met Korting)",
    "10 Koop Voordeel-woningen": "10 Koop Voordeel-woningen",
    "11 Koopcomfort-bepalingen (versie 1 april 2007, of later)": "11 Koopcomfort-bepalingen (versie 1 april 2007, of later)",
    "13 Betaalbare Koopwoningen Zaanstad (BKZ)": "13 Betaalbare Koopwoningen Zaanstad (BKZ)",
    "14 Duokoop": "14 Duokoop",
    "15 Aankoopregeling BM van Houwelingen": "15 Aankoopregeling BM van Houwelingen",
    "16 Ibb": "16 Ibb",
    "17 Brederode Koopregeling": "17 Brederode Koopregeling",
    "18 Grondvermogen": "18 Grondvermogen",
    "19 Koopinstapregeling": "19 Koopinstapregeling",
    "20 Koopstart": "20 Koopstart",
    "21 Kopen naar Wens": "21 Kopen naar Wens",
    "22 Pre Koopregeling": "22 Pre Koopregeling",
    "23 Regionaal Grondbezit": "23 Regionaal Grondbezit",
    "25 Verkopen onder Voorwaarden": "25 Verkopen onder Voorwaarden",
    "26 MVE-D": "26 MVE-D",
    "27 Meerwaardebeding": "27 Meerwaardebeding",
    "28 Koperskorting (DNGB BV)": "28 Koperskorting (DNGB BV)",
    "29 Starterskorting.nl (DNGB BV)": "29 Starterskorting.nl (DNGB BV)",
    "30 Stichting Walang": "30 Stichting Walang",
    "31 Duokoop 2023-1": "31 Duokoop 2023-1",
    "32 Omnia Wonen": "32 Omnia Wonen",
    "33 BKZ Starterswoning": "33 BKZ Starterswoning",
    "34 Kopen Met Vergoedingsregeling": "34 Kopen Met Vergoedingsregeling",
    "35 Terugkoopregeling": "35 Terugkoopregeling",
    "36 Oost West Wonen": "36 Oost West Wonen",
    "37 TinyProjectsBV-Lisserhout": "37 TinyProjectsBV-Lisserhout",
    "38 Meerwaardebeding Zelfbewoningsplicht": "38 Meerwaardebeding Zelfbewoningsplicht",
    "39 Duokoop vanaf 2023": "39 Duokoop vanaf 2023",
    "99 Anders": "99 Anders",
});
export const VerplichtingType = Object.freeze({
    "01 Alimentatieverplichting t.g.v. kinderen": "01 Alimentatieverplichting t.g.v. kinderen",
    "02 Alimentatieverplichting t.g.v. partner": "02 Alimentatieverplichting t.g.v. partner",
    "03 Pensioenpremie t.l.v. partij": "03 Pensioenpremie t.l.v. partij",
    "11 Bruto huurlasten": "11 Bruto huurlasten",
    "99 Overig": "99 Overig",
});
export const VoortitelType = Object.freeze({
    "01 aalm": "01 aalm",
    "02 adm": "02 adm",
    "03 bar": "03 bar",
    "04 biss": "04 biss",
    "05 bsse": "05 bsse",
    "06 burg": "06 burg",
    "07 comm": "07 comm",
    "08 dkn": "08 dkn",
    "09 dr": "09 dr",
    "10 dra": "10 dra",
    "11 dre": "11 dre",
    "12 drs": "12 drs",
    "13 ds": "13 ds",
    "14 gen": "14 gen",
    "15 gr": "15 gr",
    "16 htg": "16 htg",
    "17 ir": "17 ir",
    "18 jhr": "18 jhr",
    "19 kan": "19 kan",
    "20 kap": "20 kap",
    "21 kapt": "21 kapt",
    "22 kard": "22 kard",
    "23 kol": "23 kol",
    "24 kon": "24 kon",
    "25 kzr": "25 kzr",
    "26 lt gen": "26 lt gen",
    "27 maj": "27 maj",
    "28 mgr": "28 mgr",
    "29 min": "29 min",
    "30 mr": "30 mr",
    "31 pasr": "31 pasr",
    "32 pr": "32 pr",
    "33 pres": "33 pres",
    "34 prof": "34 prof",
    "35 ptr": "35 ptr",
    "36 rect": "36 rect",
    "37 sinj": "37 sinj",
    "38 weth": "38 weth",
    "39 ing": "39 ing",
    "40 da": "40 da",
    "41 lt": "41 lt",
    "42 jvr": "42 jvr",
    "43 bc": "43 bc",
    "44 bbsse": "44 bbsse",
    "45 fr": "45 fr",
    "46 frle": "46 frle",
    "47 jkvr": "47 jkvr",
    "48 rab": "48 rab",
    "49 wed": "49 wed",
    "50 zr": "50 zr",
});
export const WijzeVanTerugbetalingType = Object.freeze({
    "01 Volledig aflossen uit eigen middelen": "01 Volledig aflossen uit eigen middelen",
    "02 Volledig en/of gedeeltelijk aflossen uit vrijwillige verkoop onderpand": "02 Volledig en/of gedeeltelijk aflossen uit vrijwillige verkoop onderpand",
    "03 Het volledige en/of gedeeltelijk bedrag blijven lenen of opnieuw lenen": "03 Het volledige en/of gedeeltelijk bedrag blijven lenen of opnieuw lenen",
});
export const WoonsituatieType = Object.freeze({
    "01 Inwonend": "01 Inwonend",
    "02 Huurwoning": "02 Huurwoning",
    "03 Koopwoning": "03 Koopwoning",
});
